{
  "404.message": "找不到您嘗試連線的頁面。這可能是因為：",
  "404.message.reason1": "此頁面不存在。",
  "404.message.reason2": "此頁面存在，但您沒有其檢視權限。",
  "404.nav.dashboard": "您的儀表板",
  "404.nav.home": "網站首頁",
  "404.nav.title": "前往",
  "404.search.title": "網站搜尋",
  "aboutpage.section.title": "Atlassian Confluence Cloud 和 Confluence Cloud 外掛程式",
  "accessibility.user.icon": "使用者圖示",
  "action.add.comment": "新增留言",
  "action.edit.comment": "編輯留言",
  "action.reorder.pages.sentence": "重新排序頁面",
  "action.space.addons": "附加元件",
  "action.space.overview": "概觀",
  "actions.word": "動作",
  "add.comment": "新增留言",
  "add.comment.accesskey": "m",
  "add.shortcut": "新增捷徑",
  "add.word": "新增",
  "addlabels.teamlabels": "類別",
  "adf.translation.error.in.render.description.prod": "請重新整理頁面，然後再試一次。如果此問題持續發生，請連絡 <a target=\"_blank\" href=\"{link}\">Atlassian 支援</a>。",
  "adf.translation.error.in.render.description.staging": "ADF 錯誤導致內容無法顯示。在 <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> Slack 頻道中進一步討論。",
  "adf.translation.error.in.render.title.prod": "我們無法顯示您的內容",
  "adf.translation.error.in.render.title.staging": "顯示內容時發生 ADF 錯誤",
  "adg3.feedback.placeholder": "請說明您的 Confluence 使用體驗，以便讓我們進一步改進。",
  "adg3.give.feedback": "提供意見反應",
  "adg3.onboarding.docs.link": "深入瞭解",
  "adg3.onboarding.next": "下一頁",
  "adg3.onboarding.prev": "上一頁",
  "adg3.onboarding.sidebar.done": "了解",
  "adg3.onboarding.skip": "略過",
  "adg3.onboarding.start": "開始使用",
  "adg3.onboarding.step1.content": "我們已更新顏色、圖示和字型，讓重要事物更容易發現，而且您的眼睛也不需要那麼費力。",
  "adg3.onboarding.step1.title": "試試全新的 Confluence 體驗",
  "adg3.onboarding.step2.content": "您最需要的功能 (搜尋、建立和導覽) 全都在側邊欄中。",
  "adg3.onboarding.step2.title": "簡單側邊欄導覽",
  "adg3.onboarding.step3.content": "不記得您處理了哪些事項嗎？搜尋面板可協助您列出最近檢視的頁面。",
  "adg3.onboarding.step3.title": "從您離開的位置繼續執行",
  "adg3.onboarding.step4.content": "透過您的個人檔案留下意見反應，以協助我們使之更加完善。還沒準備好迎接新的體驗嗎？您也可以透過個人檔案將其關閉。",
  "adg3.onboarding.step4.content.no.optout": "您的意見反應在改善 Confluence 體驗方面扮演重要的角色。透過個人檔案讓我們知道您的想法，以協助我們使之更加完善。",
  "adg3.onboarding.step4.title": "協助我們建立最佳的 Confluence",
  "adg3.onboarding.user.optin.content": "我們已根據意見反應進行變更，但我們仍持續改善。如果您有更多資訊可分享，請透過側邊欄中的「提供意見反應」給我們一些回饋。",
  "adg3.onboarding.user.optin.done": "了解",
  "adg3.onboarding.user.optin.title": "全新的 Confluence 體驗現在已可供大眾使用",
  "adg3.send.feedback": "傳送意見反應",
  "adg3.sidebar.button.configure": "設定側邊欄",
  "adg3.sidebar.button.done": "完成",
  "adg3.sidebar.button.gotit": "瞭解",
  "adg3.sidebar.link.disable": "停用",
  "adg3.sidebar.link.enable": "啟用",
  "adg3.user.profile.other": "我的 Confluence",
  "admin.section.security.title": "使用者與安全性",
  "administration.name": "管理",
  "all.updates.mainBanner": "沒有發生太多事情... 然而",
  "all.updates.subBanner": "隨時掌握這個網站所發生的一切。新的頁面、檔案、編輯和評論都會顯示在這裡。",
  "all.updates.subBanner2": "是該大有作為的時候了。",
  "all.updates.title": "所有更新",
  "anonymous.name": "匿名",
  "archived.spaces": "已封存空間",
  "atlassian.can.contact": "我們是否可以與您連絡，以進一步了解您的意見反應？",
  "atlassian.home.name": "Atlassian 首頁",
  "attach.files.no.permission": "您需要要求在此插入檔案的權限。",
  "attach.files.tip.close": "好的，知道了！",
  "attach.files.tip.desc": "直接將檔案拖放到您的頁面中，即可直接插入檔案。",
  "attach.files.tip.title": "提示：",
  "attach.files.upload.files": "上傳檔案",
  "attach.files.upload.images": "上傳影像",
  "audit.logging.category.user.management": "使用者和群組",
  "aui.sidebar.collapse.tooltip": "摺疊側邊欄 ( [ )",
  "aui.sidebar.expand.tooltip": "展開側邊欄 ( [ )",
  "author.name": "作者",
  "blog.personal.name": "個人部落格",
  "blog.post": "部落格貼文",
  "blog.word": "部落格",
  "blogtree.failed.load.content": "無法載入部落格貼文",
  "blueprint.navigation.items.create.new.template": "建立新範本",
  "blueprint.navigation.items.create.new.template.disabled": "只有空間管理員可以建立範本",
  "blueprint.navigation.items.filter.for.templates": "篩選範本",
  "blueprint.navigation.items.page.templates.header": "頁面範本",
  "button.cancel": "取消",
  "cache.name.com.atlassian.confluence.pages.Draft": "草稿",
  "calendar.share.button.keyboard.shortcut.desc": "分享",
  "calendar3.addcalendar": "新增行事曆",
  "calendar3.helptip.learn.more": "深入了解",
  "calendar3.spacecalendars.header": "行事曆",
  "calendar3.spacecalendars.onboarding.button.add.label": "新增行事曆",
  "calendar3.spacecalendars.onboarding.intro": "新增行事曆以追蹤團隊的休假、規劃 Jira 專案，並且讓每個人都能夠配合重要日期行事。",
  "calendar3.spacecalendars.onboarding.title": "您團隊或專案的事實來源",
  "cancel.name": "取消",
  "captcha.response.failed": "輸入的單字與圖片中的文字不符。",
  "categories.name": "類別",
  "changeboarding.dnd.pagetree.spacesettings.banner": "空間整理已變得更加簡單，您可以使用拖放功能在側邊欄中重新排列頁面",
  "changeboarding.dnd.pagetree.spotlight.message": "拖放以移動頁面並整理空間。",
  "changes-diff.heading.key": "索引鍵",
  "changes-diff.these.lines.were.added": "此行已新增。",
  "changes-diff.these.lines.were.removed": "此行已移除。",
  "changes-diff.this.content.was.modified": "格式已變更。",
  "clear.name": "清除",
  "clipboardaccess.browser.not.supported": "您的瀏覽器不支援從剪貼簿貼上影像。",
  "clipboardaccess.ok": "確定",
  "close.draft.name": "關閉草稿",
  "close.name": "關閉",
  "collab.edit.user.limit.msg.body": "<p>這個頁面非常受歡迎，您已達到同時編輯的數目上限。</p><p>當該頁面不是那麼忙時再試一次。</p>",
  "collab.edit.user.limit.msg.title": "您現在無法編輯此頁面",
  "collab.status.connected": "準備就緒",
  "collab.status.connecting": "連結...",
  "collab.status.error": "無法儲存變更",
  "collab.status.tooltip.error": "複製您的工作、重新整理頁面，然後我們會嘗試重新連線。",
  "collab.status.tooltip.failure": "您的網際網路目前有問題。請檢查您的連線並重新整理。",
  "collab.status.tooltip.success": "我們會自動儲存您的變更，因此您永遠不需要按儲存。",
  "collapse.name": "摺疊",
  "colourname.property.style.bordercolour": "邊界和分隔線",
  "colourname.property.style.breadcrumbstextcolour": "頂端列文字",
  "colourname.property.style.headerbuttonbasebgcolour": "標頭按鈕背景",
  "colourname.property.style.headerbuttontextcolour": "標頭按鈕文字",
  "colourname.property.style.headingtextcolour": "標題文字",
  "colourname.property.style.linkcolour": "連結",
  "colourname.property.style.menuitemselectedbgcolour": "選單項目選取的背景",
  "colourname.property.style.menuitemselectedtextcolour": "功能表項目的選取文字",
  "colourname.property.style.menuitemtextcolour": "頁面功能表項目文字",
  "colourname.property.style.menuselectedbgcolour": "頁面選單選取的背景",
  "colourname.property.style.navbgcolour": "分頁導覽背景",
  "colourname.property.style.navselectedbgcolour": "分頁導覽背景醒目提示",
  "colourname.property.style.navselectedtextcolour": "分頁導覽文字醒目提示",
  "colourname.property.style.navtextcolour": "分頁導覽文字",
  "colourname.property.style.searchfieldbgcolour": "搜尋欄位背景",
  "colourname.property.style.searchfieldtextcolour": "搜尋欄位文字",
  "colourname.property.style.spacenamecolour": "空間名稱文字",
  "colourname.property.style.topbarcolour": "頂端列",
  "colourname.property.style.topbarmenuitemtextcolour": "頂端列選單項目文字",
  "colourname.property.style.topbarmenuselectedbgcolour": "頂端列選單選取的背景",
  "colourname.property.style.topbarmenuselectedtextcolour": "頂端列選單選取的文字",
  "com.atlassian.confluence.contributors.contributors.label": "參與者",
  "com.atlassian.confluence.extra.officeconnector.viewfile.label": "檢視檔案",
  "com.atlassian.confluence.extra.team-calendars.calendar.helptip.close": "了解，謝謝",
  "com.atlassian.confluence.pages.actions.EditPageAction.action.name": "編輯頁面",
  "com.atlassian.confluence.plugins.confluence-roadmap-plugin.roadmap.label": "藍圖規劃工具",
  "com.atlassian.confluence.plugins.pagetree.pagetree.label": "頁面樹狀結構",
  "com.atlassian.confluence.plugins.recently.viewed.filter": "篩選",
  "com.atlassian.confluence.plugins.recently.viewed.footer.hint": "提示：鍵入 \"g\"，然後在任意處鍵入 \"r\" 快速開啟此選單",
  "com.atlassian.confluence.plugins.recently.viewed.title": "最近檢視的頁面",
  "com.atlassian.confluence.plugins.status-macro.status.label": "狀態",
  "com.atlassian.mywork.header.notifications": "通知",
  "comment.display.name.anonymous": "匿名",
  "comment.edit": "編輯",
  "comment.edited": "已編輯",
  "comment.name.tooltip": "新增留言",
  "comment.notification.enable": "追蹤此頁面",
  "comment.permalink": "永久連結",
  "comment.plural": "{0} 則留言",
  "comment.remove": "刪除",
  "comment.reply": "回覆",
  "comment.singular": "1 則留言",
  "compare.selected": "比較所選的版本",
  "configuration.name": "組態",
  "confluence.extra.attachments.attachments.label": "附件",
  "confluence.extra.jira.jira.label": "Jira",
  "confluence.extra.masterdetail.detailssummary.label": "頁面屬性報告",
  "confluence.home": "Confluence 首頁",
  "confluence.macros.advanced.children.label": "子系顯示",
  "confluence.macros.advanced.contentbylabel.label": "依標籤分類的內容",
  "confluence.macros.advanced.recently-updated.label": "最近更新",
  "confluence.mobile.nav.switch.to.mobile.action": "切換至 Confluence Mobile",
  "confluence.mobile.nav.switch.to.mobile.text": "您正在行動裝置上檢視桌面版本。",
  "confluence.mobile.refresh": "重新整理",
  "confluence.request.access.pagerestricted.inherited.description": "這是因為其沿用父系頁面的限制。空間管理員或分享此頁面的人員能夠將存取權授予您。",
  "confluence.request.access.pagerestricted.request.access.button": "要求存取權",
  "confluence.request.access.pagerestricted.requestaccess.description": "點擊要求存取按鈕，我們會尋找可以提供您存取權的人。",
  "confluence.request.access.pagerestricted.requestaccess.title.edit.page": "您沒有編輯此頁面的權限",
  "confluence.request.access.pagerestricted.requestaccess.title.view.page": "您沒有檢視此頁面的權限。",
  "confluence.user.profile.department": "部門",
  "confluence.user.profile.location": "位置",
  "confluence.user.profile.position": "位置",
  "connect.addon.wait.or": "等待或",
  "content.empty": "留言文字是空的。無法建立空白留言。",
  "content.kind.decisions": "決策",
  "content.kind.file-list": "檔案清單",
  "content.kind.jirareport": "Jira 報告",
  "content.kind.kb-how-to-article": "操作說明文章",
  "content.kind.kb-troubleshooting-article": "疑難排解文章",
  "content.kind.meeting-notes": "會議記錄",
  "content.kind.product-requirements": "產品需求",
  "content.kind.retrospective": "回顧",
  "content.kind.shared-links": "分享的連結",
  "content.kind.task-report": "任務報告",
  "content.type.attachment": "附件",
  "content.type.blogpost": "部落格",
  "content.type.page": "頁面",
  "cq.header.title": "問題",
  "create.blog.post.event.description": "建立部落格貼文",
  "create.drawer.header": "建立",
  "create.drawer.page.selector.all.pages.in.space": "此空間中的所有頁面",
  "create.drawer.page.selector.location.header": "位置",
  "create.drawer.page.selector.no.page.found": "找不到頁面",
  "create.drawer.page.selector.no.parent.page": "沒有父系頁面",
  "create.drawer.page.selector.pages.loading": "正在載入頁面",
  "create.drawer.page.selector.parent.page": "父系頁面",
  "create.drawer.page.selector.parent.page.tooltip.help": "部落格、行事曆和問題將不會出現在父系頁面之下",
  "create.drawer.page.selector.recent.pages": "最近使用的頁面",
  "create.drawer.page.selector.select.parent.page": "選取父系頁面",
  "create.drawer.space.selector.header": "空間",
  "create.drawer.space.selector.location.header": "位置",
  "create.drawer.space.selector.no.space.found": "找不到空間",
  "create.drawer.space.selector.recent.spaces": "最近存取的空間",
  "create.drawer.space.selector.search.spaces": "所有空間",
  "create.drawer.space.selector.select.a.space": "選取空間",
  "create.drawer.space.selector.spaces.loading": "正在載入空間",
  "create.drawer.space.selector.starred.spaces": "已標上星號的空間",
  "create.drawer.template.failed.to.load.atlassian.support": "Atlassian 支援。",
  "create.drawer.template.failed.to.load.content": "請重新整理頁面，然後再試一次。如果問題持續發生，請連絡",
  "create.drawer.template.failed.to.load.title": "無法載入範本",
  "create.name": "建立",
  "css.file": "CSS 檔案",
  "current.space": "目前空間",
  "default.space.homepage.title": "{0} 首頁",
  "delete.name": "刪除",
  "desc.colourscheme": "您可以為此顏色配置自訂下列顏色。",
  "description.name": "描述",
  "discard.name": "捨棄",
  "discover.applications": "探索應用程式",
  "draft": "草稿",
  "draft.no.content": "此草稿沒有內容。",
  "edit.comment": "編輯留言",
  "edit.labels": "新增標籤",
  "editor-help.fabric.help.center.feedback.item": "意見反應",
  "editor.adf.parsing.error.details": "錯誤詳細資料：",
  "editor.adf.parsing.error.message.prod": "請重新整理頁面，然後再試一次。如果此問題持續發生，請連絡 <a target=\"_blank\" href=\"{link}\">Atlassian 支援</a>。",
  "editor.adf.parsing.error.message.staging": "我們的團隊已收到通知，但您也可以在 Slack 的 <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> 頻道中討論此問題。",
  "editor.adf.parsing.error.title.prod": "我們無法載入編輯器。",
  "editor.adf.parsing.error.title.staging": "將此文件轉換為 ADF 時發生問題",
  "editor.attachments": "{0}",
  "editor.attachments.plural": "{0} 個附件",
  "editor.attachments.singular": "{0} 附件",
  "editor.attachments.zero": "附件",
  "editor.autocomplete.file.header.text": "檔案建議",
  "editor.autocomplete.links.create.link": "插入連結以建立頁面",
  "editor.autocomplete.links.dialog.search": "搜尋 ''{0}'",
  "editor.autocomplete.links.dialog.search.no.text": "搜尋",
  "editor.autocomplete.links.header.text": "連結建議",
  "editor.autocomplete.links.web.link": "插入 Web 連結",
  "editor.autocomplete.macros.dialog.browse": "開啟巨集瀏覽器",
  "editor.autocomplete.macros.error.load.header": "無法取得巨集詳細資料",
  "editor.autocomplete.macros.error.load.retrylink": "再試一次",
  "editor.autocomplete.macros.header.text": "巨集建議",
  "editor.autocomplete.media.files.dialog.browse": "開啟檔案庫",
  "editor.autocomplete.media.header.text": "媒體建議",
  "editor.autocomplete.media.images.dialog.browse": "開啟圖片瀏覽器",
  "editor.autocomplete.media.macros.dialog.browse": "插入其他媒體",
  "editor.autoformat.sampletext.firstcell": "第一個儲存格",
  "editor.autoformat.sampletext.heading": "標題",
  "editor.buttons.disable.by.empty.title.tooltip": "您的頁面需有標題，才能進行發佈。",
  "editor.buttons.disable.by.not.saving.tooltip": "仍在處理中...",
  "editor.buttons.disable.by.saving.tooltip": "我們仍會儲存您的頁面。",
  "editor.cancel.discard.changes.confirmation": "捨棄變更",
  "editor.cancel.discard.changes.message": "所有輸入的內容將被捨棄。請確認。",
  "editor.cancel.discard.changes.title": "確認捨棄所有變更",
  "editor.cant.publish.changes": "無法發布變更",
  "editor.change.comment": "您變更了什麼？",
  "editor.close.publish.tooltip": "儲存變更而不發布",
  "editor.close.update.tooltip": "儲存變更而不更新",
  "editor.collab.user.limit.body": "這個頁面非常受歡迎，您已達到同時編輯的數目上限。當該頁面不是那麼忙時再試一次。",
  "editor.collab.user.limit.title": "您現在無法編輯此頁面",
  "editor.collaborative-editing.load.error": "載入此頁面的時間比平時更久。請稍候，然後嘗試重新載入。如果仍然無法載入，請與您的 Confluence 管理員聯繫。",
  "editor.collaborative-editing.refresh-editor.error": "載入編輯器時發生問題，請再試一次。",
  "editor.collaborative.mode.disabled": "協同編輯現已離線。複製您的作品，然後重新整理頁面以繼續編輯。",
  "editor.collaborative.mode.enabled": "協作編輯已關閉，但又恢復運作。複製您的變更，然後重新整理頁面以繼續編輯。",
  "editor.content.appearance.toggle.fixed.width": "讓頁面變成全寬",
  "editor.content.appearance.toggle.full.width": "讓頁面變成全寬",
  "editor.content.placeholder.11": "您知道您可以在此頁面中新增目錄、日期或藍圖等各式各樣的酷炫項目嗎？鍵入 / 以開啟清單。",
  "editor.content.placeholder.ai": "輸入 /ai 即表示 Atlassian Intelligence，輸入 / 可新增元素，輸入 @ 可提及某人 (我們會通知他們)。",
  "editor.content.placeholder.bpqa": "輸入 / 即可查看元素列表，輸入 @ 可提及某人，也可以從下方選取：",
  "editor.content.placeholder.bpqa.ai": "輸入 /ai 即表示 Atlassian Intelligence，/ 表示元素，@ 可提及某人，也可以從下方選取：",
  "editor.content.placeholder.easy.mentions": "輸入 / 可查看所有元素，輸入 @ 可提及某人。",
  "editor.content.placeholder.slash": "輸入 / 以插入任何元素",
  "editor.content.placeholder.slash.bracket": "任何元素均可藉由鍵入 / 快速插入",
  "editor.content.reconciliation.error.details": "錯誤詳細資料：",
  "editor.content.reconciliation.error.fatal.prod": "我們的團隊已收到通知。稍候數分鐘，然後再試一次。如果此問題持續發生，請連絡 Atlassian 支援。",
  "editor.content.reconciliation.error.fatal.staging": "我們的團隊已收到通知，但您也可以在 Slack 的 #cc-content-experience 頻道中討論此問題。",
  "editor.content.reconciliation.error.retrying": "正在 {0} 中重試...",
  "editor.content.reconciliation.error.title": "此頁面載入失敗",
  "editor.content.reconciliation.networkerror.fatal.prod": "重新整理頁面應該可以修正此問題。如果問題持續發生，請連絡 <a href=\"https://support.atlassian.com/contact/#/\" target=\"_blank\">Atlassian 支援</a>或空間管理員。",
  "editor.content.reconciliation.networkerror.title": "我們無法載入您的內容",
  "editor.discard-on-close.tooltip": "捨棄空白草稿",
  "editor.discard-to-published.button.label": "捨棄",
  "editor.discard-to-published.button.tooltip": "恢復到頁面上次發布的版本",
  "editor.discard-to-published.dialog.title": "是否捨棄未發佈的變更？",
  "editor.discard-to-published.dialog.warning": "這會將編輯器還原到此頁面上次發佈的版本。如果其他人在頁面上有未發佈的變更，您也會捨棄這些變更。",
  "editor.discard-to-published.error.message": "我們目前無法取得目前發佈的頁面版本。請稍後一下，然後嘗試再次捨棄草稿。",
  "editor.discard-to-published.error.title": "無法回復至上次發佈的版本",
  "editor.discard-to-published.success.message": "已成功恢復為上次發佈的版本",
  "editor.draft.can.be.migrated": "請在此處進行協同編輯！為了讓您可以繼續在此頁面上工作，我們需要將內容移轉到新的草稿。<br><a href={0}>立即移轉 </a>",
  "editor.dynamic-macro.preview.limit.desc": "只有在啟用分享草稿的功能時，才能完全支援草稿上的動態巨集預覽。",
  "editor.ellipsis.blog.delete": "刪除未發佈的部落格貼文",
  "editor.ellipsis.import-document": "開啟範本並匯入文件",
  "editor.ellipsis.open.template.browser": "開啟範本瀏覽器",
  "editor.ellipsis.open.templates.and.import": "範本和匯入文件",
  "editor.ellipsis.page.delete": "刪除未發佈的頁面",
  "editor.ellipsis.remove": "恢復為上次發佈的版本",
  "editor.ellipsis.resolved.comments": "已解決的留言",
  "editor.ellipsis.view-changes": "檢視變更",
  "editor.error.delayed.publishing": "我們會持續嘗試發布。如果花費時間太長，請重新整理頁面並按一下<strong>發布</strong>。",
  "editor.error.delayed.publishing.title": "我們在發布您的內容時遇到問題。",
  "editor.excerpt.include.macro.error": "載入「{0}」的摘錄時發生錯誤。",
  "editor.excerpt.panel.title.loading": "正在載入...",
  "editor.fabric.share.invite.to.edit.empty.blog.post.title": "未命名的部落格貼文",
  "editor.fabric.share.invite.to.edit.empty.page.title": "未命名的頁面",
  "editor.fabric.share.invite.to.edit.form.title": "邀請進行編輯",
  "editor.files.may.be.uploading": "某些檔案可能仍在上傳中。請稍候，然後再試一次。如果無法運作，請重新整理頁面，然後重新上傳在發布前出現損壞的任何檔案。",
  "editor.generic.refresh": "編輯器發生錯誤。複製未儲存的變更並重新整理頁面以繼續編輯。",
  "editor.go.back": "返回",
  "editor.heartbeat.unauthorised.warning.generic.body": "此內容已移動、受到限制或遭到刪除。我們建議您複製您需要的任何內容並關閉編輯器。",
  "editor.heartbeat.unauthorised.warning.generic.title": "無法存取此頁面",
  "editor.heartbeat.unauthorised.warning.page-move.body": "由於頁面移動或變更限制，您無法發佈。我們建議您複製您需要的任何內容並關閉編輯器。",
  "editor.heartbeat.unauthorised.warning.page-move.title": "頁面權限已變更",
  "editor.help.how.to.use.blueprint": "如何使用 {blueprintType}",
  "editor.help.templates": "使用頁面範本",
  "editor.help.updates": "編輯更新",
  "editor.help.updates.1.description": "編輯改進的第一個階段已經落在部落格貼文上。回應式內容、更好的影像處理，以及更簡化的介面。建立新的部落格貼文來加以查看。",
  "editor.help.updates.1.title": "部落格貼文",
  "editor.help.updates.2.description": "新的編輯體驗現已推廣至會議記錄。最新的更新包括藉由按一下表格來切換的進階表格功能，以及速度和可靠性方面的改善。",
  "editor.help.updates.2.title": "會議記錄",
  "editor.hints.close": "關閉提示",
  "editor.hints.next": "下一個提示",
  "editor.labels": "{0}",
  "editor.labels.desc": "編輯頁面標籤",
  "editor.labels.plural": "{0} 個標籤",
  "editor.labels.singular": "{0} 標籤",
  "editor.labels.zero": "標籤",
  "editor.learn.more": "深入瞭解",
  "editor.location.desc": "新增位置",
  "editor.minor.edit": "通知追蹤者",
  "editor.offline.before.save.error": "無法與伺服器通訊。目前無法儲存。",
  "editor.offline.preview.error": "無法連線到伺服器。請檢查您是否已連線至網際網路，以及 Confluence 是否已啟動並執行。",
  "editor.offline.save.error": "無法與伺服器通訊。目前無法儲存。",
  "editor.offline.save.error.generic": "處理要求時發生錯誤。",
  "editor.offline.save.noauthorized": "您的工作階段已到期。您必須再次登入或切換為其他帳號才能繼續運作。\n<div><a href=\"/login?application=confluence\">登入或切換為其他帳號</a></div>",
  "editor.offline.save.noauthorized.title": "無法連線至伺服器",
  "editor.offline.save.page.exist.content": "標題為 '{'0'}' 的頁面已存在於此空間中。請為您的頁面輸入不同的標題。",
  "editor.onboarding.draft.placeholder": "輸入 / 以取得可新增至頁面的實用元素清單，例如目錄或藍圖。<br/>或者，若您毫無頭緒，請從右側的其中一個範本開始 →",
  "editor.onboarding.spotlight.body": "瞭解變更內容及原因。",
  "editor.onboarding.spotlight.finish": "瞭解",
  "editor.onboarding.spotlight.title": "我們正在逐一更新您的範本",
  "editor.onboarding.step1.content": "我們正努力提供您一直要求的功能，從提高可讀性、更聰明的格式化工具和更現代化的外觀開始。<br /><a href=\"{linkCAC}\" target=\"_blank\">深入了解改變內容</a>",
  "editor.onboarding.step1.title": "較友善的部落格貼文",
  "editor.onboarding.step2.content": "您最常使用的功能位於工具列中，而更進階的工具則位於加號下方。您也有一堆新的表情符號可以讓您開心起來！<br/> <a href=\"{linkCAC}\" target=\"_blank\">進一步了解變更內容</a>",
  "editor.onboarding.step2.title": "您在尋找某個項目嗎？",
  "editor.onboarding.step3.content": "這是一項正在進行中的工作，我們需要您的協助來讓成果變得更棒。請將意見反應傳送給我們，並追蹤 <a href=\"{linkCAC}\" target=\"_blank\">Confluence 頁面</a>來掌握最新的變更。<br/><a href=\"{linkCAC}\" target=\"_blank\">深入瞭解改變內容</a>",
  "editor.onboarding.step3.title": "讓我們一起創造偉大的事物",
  "editor.page.can.not.be.accessed.message": "您的工作階段可能已到期。您必須再次登入或切換為其他帳號才能繼續運作。\n<div><a href=\"/login?application=confluence\">登入或切換為其他帳號</a></div>",
  "editor.page.can.not.be.accessed.title": "無法存取此內容。",
  "editor.page.conflict.message": "重新整理頁面，以嘗試重新建立連線。",
  "editor.page.conflict.title": "無法與伺服器同步。",
  "editor.page.is.too.big": "此頁面太大而無法儲存。您可以將其分成多個頁面，然後使用<a href=\"https://confluence.atlassian.com/conf51/include-page-macro-336169384.html\" target=\"_blank\">包含頁面巨集</a>來顯示內容。",
  "editor.page.is.trashed.message": "複製您的內容，然後將其新增至新頁面，或<div><a href=\"{0}/pages/viewtrash.action?key={1}\" target=\"_blank\">從垃圾桶還原此頁面</a>，然後再試一次。</div>",
  "editor.page.is.trashed.title": "此內容已被刪除",
  "editor.page.legacy.draft.deprecated": "已可使用協作編輯！這表示我們需要您的一些協助，才能重新啟動編輯工作階段。您需要做的就是複製內容、再次編輯此頁面，然後將其貼上並儲存。",
  "editor.page.moved.message.body": "不過，沒關係 - 您仍然可以在準備好時發佈您所做的變更。<br /><br />新位置：{0}",
  "editor.page.moved.message.title": "{0} 已移動此頁面",
  "editor.page.moved.message.unknown.mover": "其他使用者",
  "editor.placeholder.broken.image": "損壞的影像",
  "editor.placeholder.broken.link": "損壞的連結",
  "editor.placeholder.broken.macro": "損壞的巨集",
  "editor.placeholder.error": "錯誤",
  "editor.preview.error": "載入預覽時發生錯誤。請稍後再試一次。",
  "editor.publish.blog": "發佈",
  "editor.publish.blog.desc": "發佈您的部落格貼文",
  "editor.publish.external.share.label": "外部分享",
  "editor.publish.hotkey.description": "若要發布此內容，請在鍵盤上選取 {keyCombination}。",
  "editor.publish.with.comment": "與版本留言一起發佈...",
  "editor.publish.without.notify": "在不通知追蹤者的情況下發佈",
  "editor.quit-dialog.button.delete.blog.exit": "刪除部落格貼文",
  "editor.quit-dialog.button.delete.page.exit": "刪除頁面",
  "editor.quit-dialog.button.discard.changes.by.many": "捨棄<strong>每個人的</strong>變更",
  "editor.quit-dialog.button.discard.changes.by.one": "捨棄<strong>所有</strong>變更",
  "editor.quit-dialog.button.discard.collaborative.tooltip": "捨棄所有未發佈的變更",
  "editor.quit-dialog.button.discard.limited.tooltip": "協同編輯已停用。您可以在再次啟用時捨棄變更。",
  "editor.quit-dialog.button.revert.blog.exit": "恢復部落格貼文",
  "editor.quit-dialog.button.revert.page.exit": "恢復頁面",
  "editor.quit-dialog.button.save.exit": "保留草稿",
  "editor.quit-dialog.cancel.changes.by.many": "<p>您和其他人所做的變更尚未發佈。</p>\n<p>如果您捨棄變更，您將刪除下列使用者所做的變更，並回復至此頁面的上次發佈版本。如果您這麼做，下列使用者將無法復原其變更。</p>\n\n<p>執行變更的人如下：</p>",
  "editor.quit-dialog.cancel.changes.by.one": "<p>您所做的變更尚未發佈。</p><p>如果您捨棄變更，未發佈的變更將會遭到刪除。您無法復原此動作。</p>",
  "editor.quit-dialog.delete.blogpost.changes.by.many": "這會永久刪除此部落格貼文，該頁面就是您和其他人曾經處理過的頁面。",
  "editor.quit-dialog.delete.blogpost.changes.by.one": "一旦刪除未發佈的部落格貼文，該貼文就會永遠消失。",
  "editor.quit-dialog.delete.page.changes.by.many": "這會永久刪除此頁面，該頁面就是您和其他人曾經處理過的頁面。",
  "editor.quit-dialog.delete.page.changes.by.one": "如果您刪除未發佈的頁面，則頁面會永久消失。",
  "editor.quit-dialog.last.edited": "上次編輯",
  "editor.quit-dialog.link.hide.diff": "隱藏變更",
  "editor.quit-dialog.link.show.diff": "顯示變更",
  "editor.quit-dialog.publish.changes": "您也會發佈以下人員所做的變更：",
  "editor.quit-dialog.revert.blogpost.changes.by.one": "這會永久刪除自上次發佈此部落格貼文以來您所做的所有變更。",
  "editor.quit-dialog.revert.changes.by.many": "這將會永久刪除自從上次發佈此頁面以來，下列人員所做的所有變更。",
  "editor.quit-dialog.revert.page.changes.by.one": "這將會永久刪除自上次發佈此頁面以來您所做的所有變更。",
  "editor.quit-dialog.title.blogpost.delete": "是否刪除未發佈的部落格貼文？",
  "editor.quit-dialog.title.discard": "恢復為上次發佈的版本？",
  "editor.quit-dialog.title.exit": "關閉編輯器",
  "editor.quit-dialog.title.page.delete": "刪除未發佈的頁面？",
  "editor.quit-dialog.title.publish": "要發佈頁面嗎？",
  "editor.restrictions.desc": "編輯頁面限制",
  "editor.return.to.edit": "返回編輯模式",
  "editor.satisfaction.survey.description": "您的編輯體驗如何？",
  "editor.satisfaction.survey.final.description": "您的意見反應已提交",
  "editor.satisfaction.survey.final.title": "謝謝",
  "editor.satisfaction.survey.question.bad": "我們很遺憾得知這個消息。出了什麼問題？(選擇性)",
  "editor.satisfaction.survey.question.good": "謝謝您！您喜歡其中哪一個部分？有什麼可以改進的嗎？(選擇性)",
  "editor.satisfaction.survey.title": "您的頁面已發佈",
  "editor.save.draft.desc": "儲存您的草稿",
  "editor.save.page.desc": "儲存您的頁面",
  "editor.shared.draft.done.desc": "儲存草稿；如為空白，則將其捨棄",
  "editor.shared.draft.publish.desc": "發佈變更",
  "editor.shared.draft.update.desc": "更新發佈的頁面",
  "editor.shortcuts": "編輯鍵盤快速鍵",
  "editor.synchrony.publish-page.message": "{0} 已發佈此頁面。",
  "editor.template.changing.variable.dialog.title": "編輯範本變數",
  "editor.template.variable.input.creation.error.action": "造訪 Atlassian 支援",
  "editor.template.variable.input.creation.error.description": "請重新整理頁面，然後再試一次。如果這種狀況持續發生，請使用下方連結讓我們知道。",
  "editor.template.variable.input.creation.error.title": "發生錯誤",
  "editor.template.variable.list.field.placeholder": "選項 1、選項 2、選項 3",
  "editor.template.variable.name.field": "變數名稱",
  "editor.title.is.empty": "請在點擊發佈之前新增頁面標題。",
  "editor.title.is.empty.title": "此頁面需要一個名稱",
  "editor.title.placeholder": "給此頁面一個標題",
  "editor.title.too.long": "標題不能超過 255 個字元。",
  "editor.unavailable.generic.body": "目前無法進行編輯。請在數分鐘之後再試一次。",
  "editor.unavailable.title": "無法編輯",
  "editor.unpublished.changes.lozenge.label": "未發佈",
  "editor.unpublished.changes.lozenge.tooltip": "此頁面有未發佈的變更",
  "editor.waiting.to.publish.changes": "檔案上傳可能仍在進行中。",
  "editor.waiting.to.publish.changes.title": "請耐心等候，這需要一點時間。",
  "email.text.added.by": "新增者",
  "error.connection.lost.body": "我們會在這裡等您重新連線。",
  "error.connection.lost.title": "您似乎已經失去連線。",
  "error.connection.recovered.action": "重新載入內容",
  "error.connection.recovered.title": "再次連線",
  "error.notfound.title": "糟糕，我們找不到該頁面。",
  "error.recovery.body": "您的變更是安全的。請重新整理頁面，然後再試一次。",
  "error.recovery.title": "載入編輯器時發生錯誤",
  "error.server-error.body": "請稍後再試。",
  "error.server-error.title": "發生問題。",
  "error.session.expired.body": "我們保證下次會更穩定。",
  "error.session.expired.title": "看來我們失去了您的工作階段。",
  "excel.file": "Microsoft Excel 試算表",
  "excel.macro.file": "Microsoft Excel 巨集啟用的試算表",
  "excel.template.file": "Microsoft Excel 範本",
  "excel97.file": "Microsoft Excel 工作表",
  "excel97.template.file": "Microsoft Excel 97 範本",
  "existing.blogpost.placeholder": "部落格貼文標題",
  "expand-macro.default-title": "按一下此處以展開...",
  "expand.name": "展開",
  "fabric.editor.announcement.datednotice.main": "在 {0}，您將獲得升級，可享有我們全新的編輯體驗。",
  "fabric.editor.announcement.dismiss": "關閉",
  "fabric.editor.announcement.greeting": "{0} 您好，",
  "fabric.editor.announcement.initialnotice.main": "在幾週內，您在 Confluence 上建立內容的方式將會改變。",
  "fabric.editor.announcement.link.action": "瞭解變更內容，以及您將獲得哪些新功能。",
  "fabric.editor.announcement.rollbacknotice.action": "請閱讀有關如何讓現有頁面回到舊有體驗的公告。",
  "fabric.editor.announcement.rollbacknotice.main": "您的頁面在最近不小心更新為新的編輯體驗。我們現在已經將其回復。",
  "fabric.editor.announcement.tryit.action": "在新的頁面上試試。",
  "fabric.editor.announcement.tryitnotice.main": "全新的編輯體驗為您提供更美觀的頁面，以及即時巨集等新功能。",
  "fabric.editor.changeboarding.banner.action": "看看您能做些什麼新鮮事。",
  "fabric.editor.changeboarding.banner.dismiss": "關閉",
  "fabric.editor.changeboarding.banner.main": "{0} 您好，為了協助您建立更美觀、更容易閱讀的內容，我們正在進行一些變更。",
  "fabric.editor.page.removed.description": "請立即重新整理。",
  "fabric.editor.page.removed.title": "此頁面最近已封存或刪除",
  "fabric.editor.permission.removed.description": "已變更此頁面的權限。請連絡管理員以取得協助。",
  "fabric.editor.permission.removed.title": "我們無法顯示此頁面",
  "fabric.full.width.help.center.dialog.title": "新增！寬度控制",
  "fabric.full.width.help.center.pageElement.details": "水平<p>展開<strong>所有頁面元素</strong>，這會導致空白區域減少。切換也會使頁面內容恢復成固定寬度。</p>",
  "fabric.full.width.help.center.pageElement.title": "全寬頁面切換",
  "fabric.full.width.help.center.tableElement.details": "<p>使用寬度或全寬選項來控制<strong>每個欄、表格</strong>和大多數<strong>巨集</strong>的寬度；您也可以將某些元素鎖定在固定寬度。</p>",
  "fabric.full.width.help.center.tableElement.title": "個別元素切換",
  "fabric.help.center.columns.details": "<p>在您的頁面上新增<strong>欄</strong>，然後使用<strong>浮動選單</strong>來切換 2 或 3 欄組態。</p>",
  "fabric.help.center.columns.title": "欄",
  "fabric.help.center.dialog.title": "瞭解基本知識",
  "fabric.help.center.imageDisplay.details": "<p>選取影像，然後拖曳<strong>控制點</strong>以調整其大小，或使用<strong>浮動功能表</strong>來變更其對齊方式。</p>",
  "fabric.help.center.imageDisplay.title": "影像顯示",
  "fabric.help.center.layouts.details": "<p>使用 <kbd>←</kbd> <kbd>→</kbd> 來變更欄、表格和巨集的版面配置。</p><p>您可以選擇<strong>固定寬度</strong>來讓畫面上的所有寬度都一樣、選擇<strong>全寬</strong>來延展並填滿空間，或是選擇兩者之間的<strong>寬度</strong>設定。</p>",
  "fabric.help.center.layouts.title": "版面配置",
  "fabric.help.center.menuitem.title": "教學課程",
  "fabric.help.center.slashCommands.details": "<p>鍵入 <kbd>/</kbd> 以開啟功能表，然後在您的頁面中隨意插入<strong>表格</strong>、<strong>巨集</strong>和<strong>日期</strong>等內容。</p>",
  "fabric.help.center.slashCommands.title": "斜線指令",
  "fabric.help.center.spotlight.body": "請隨時回到這裡來重溫教學課程。",
  "fabric.help.center.spotlight.header": "需要重溫一下嗎？",
  "fabric.help.center.tableManipulation.details": "<p>從<strong>表格邊界</strong>、<strong>下拉式清單</strong>和<strong>浮動選單</strong>中編輯和格式化表格。</p>",
  "fabric.help.center.tableManipulation.title": "表格操作",
  "fabric.help.center.templates.details": "<p>尋找符合您需求的範本。如果面板已關閉，請從「更多動作 (•••)」選單中重新開啟面板。</p>",
  "fabric.help.center.templates.title": "範本",
  "fabric.help.center.title": "瞭解基礎知識",
  "fabric.insert.external.image": "從 Web 插入影像",
  "fabric.template.can.not.parse.content": "我們無法開啟此範本，因為其中包含損毀或不支援的元素。",
  "fabric.template.can.not.save.error.title": "無法儲存變更",
  "fabric.template.can.not.save.error.title.duplicate": " 已經有一個名為 <strong>{0}</strong> 的範本。為您的範本提供不同的標題以便儲存。",
  "fabric.template.found.invalid.node": "具有相同名稱 \"{variableNames}\" 但不同參數的多個範本變數。",
  "favourite.spaces": "我的空間",
  "feedback.flag.thanks.description": "您的意見反應可協助我們打造更好的體驗。",
  "feedback.flag.thanks.title": "謝謝您！",
  "filter.name": "篩選",
  "gif.file": "GIF 檔案",
  "global.spaces": "網站空間",
  "globaladminbilling.label": "帳單",
  "header.or.footer.unsupported.macros.list": "{0} 中目前不支援下列巨集：",
  "header.or.footer.unsupported.macros.title": "不支援的巨集",
  "heading.comment": "變更者",
  "heading.createpage": "建立頁面",
  "heading.createpage.sentence": "建立頁面",
  "heading.operations": "作業",
  "heading.version.date": "日期",
  "heading.version.number": "版本",
  "help.name": "說明",
  "help.us.improve": "協助我們改善",
  "hipchat.presence.status.available": "可用",
  "hipchat.presence.status.away": "離開",
  "hipchat.presence.status.dnd": "請勿打擾",
  "hipchat.presence.status.offline": "離線",
  "html.file": "HTML 檔案",
  "icon.tooltip.remove": "移除",
  "icon.tooltip.undo": "復原",
  "image.browser.imageurl.label": "影像 URL",
  "image.height": "高度",
  "image.properties.dialog.cancel": "取消",
  "image.properties.dialog.heading": "影像屬性",
  "image.properties.trigger": "屬性",
  "image.properties.trigger.tooltip": "設定其他影像屬性",
  "inline.comment.sidebar.navigate.next.description": "下一則內嵌留言",
  "inline.comment.sidebar.navigate.previous.description": "上一則內嵌留言",
  "inline.comments.GROW-1507.dialog.close.label": "關閉",
  "inline.comments.GROW-1507.dialog.content": "您知道內嵌留言嗎？<br>您可以使用它們進行評論，並將它們新增到文件的特定部分。",
  "inline.comments.GROW-1507.dialog.header": "內嵌留言",
  "inline.comments.GROW-1507.dialog.ok.label": "好的，明白了",
  "inline.comments.GROW-1507.dialog.showme.label": "展示",
  "inline.comments.GROW-1507.dialog.title": "留言提示",
  "inline.comments.batch.email.view": "檢視留言",
  "inline.comments.create.placeholder": "撰寫留言...",
  "inline.comments.create.reply.placeholder": "回覆",
  "inline.comments.date.friendly.about.one.hour.ago": "1 小時前",
  "inline.comments.date.friendly.about.x.days.ago": "{0} 天前",
  "inline.comments.date.friendly.about.x.hours.ago": "{0} 小時前",
  "inline.comments.date.friendly.formatted": "{0}",
  "inline.comments.date.friendly.now": "剛才",
  "inline.comments.date.friendly.one.min.ago": "1 分鐘前",
  "inline.comments.date.friendly.x.mins.ago": "{0, plural, other {{0} 分鐘前}}",
  "inline.comments.date.friendly.yesterday": "昨天",
  "inline.comments.delete.confirmation.message": "您確定要刪除此留言嗎？",
  "inline.comments.delete.permission": "您沒有刪除此留言的權限。",
  "inline.comments.delete.reply.confirmation.message": "您確定要刪除此回覆嗎？",
  "inline.comments.delete.with.reply": "您無法刪除內嵌留言討論串，因為已有人回覆。",
  "inline.comments.delete.with.reply.need.reload": "您無法刪除此留言，因為此討論串有新的回覆。請重新載入加以檢視。",
  "inline.comments.edit.permission": "您沒有編輯此留言的權限。",
  "inline.comments.editor.lost": "您的留言將會遺失。",
  "inline.comments.editor.timeout": "編輯器並未正確載入。請{0}重新載入頁面{1}，以再試一次。",
  "inline.comments.expand.replies": "還有 {0} 個回覆",
  "inline.comments.fabric.editor.error.cannot.be.empty": "您的留言是空的。新增意見反應，然後按一下「儲存」。",
  "inline.comments.fabric.editor.error.captcha.check.failed": "驗證碼確認失敗",
  "inline.comments.fabric.editor.error.captcha.check.succeeded": "驗證碼檢查成功",
  "inline.comments.fabric.editor.error.create.not.permitted": "您的權限設定不允許您建立留言。如果您需要此能力，請洽詢您的管理員。",
  "inline.comments.fabric.editor.error.delete.not.permitted": "您的權限設定不允許您刪除留言。如果您需要此能力，請洽詢您的管理員。",
  "inline.comments.fabric.editor.error.edit.not.permitted": "您的權限設定不允許您編輯留言。如果您需要此能力，請洽詢您的管理員。",
  "inline.comments.fabric.editor.error.invalid.selection": "無法建立留言。請在更獨特的文字上建立醒目提示，讓選擇項目不一樣，以便您的留言能對應到正確內容。",
  "inline.comments.fabric.editor.error.resolve.not.permitted": "您的權限設定不允許您解決留言。如果您需要此能力，請洽詢您的管理員。",
  "inline.comments.fabric.editor.error.unexpected": "儲存此留言時發生問題。請關閉留言或重新整理頁面，然後再次嘗試新增留言。",
  "inline.comments.fabric.editor.error.view.not.permitted": "您的權限設定不允許您檢視此留言。如果您需要此能力，請洽詢您的管理員。",
  "inline.comments.fabric.inline.button.cancel": "取消",
  "inline.comments.fabric.inline.button.save": "儲存",
  "inline.comments.fabric.sidebar.loading.error": "發生錯誤，請關閉留言視窗，然後再試一次",
  "inline.comments.likes.error": "無法更新按讚數。",
  "inline.comments.likes.like": "讚",
  "inline.comments.likes.unlike": "收回讚",
  "inline.comments.navigation.index.of": "第 {0} 個，共 {1} 個",
  "inline.comments.notification.email.reopened": "已重新開啟",
  "inline.comments.notification.email.resolved": "已解決",
  "inline.comments.notification.email.view": "檢視留言",
  "inline.comments.resolve.permission": "您沒有解決此留言的權限。",
  "inline.comments.resolved.dangling.message": "已解決，因為文字已由 {0} {1} 刪除",
  "inline.comments.resolved.dialog.empty": "此頁面上沒有已解決的留言。",
  "inline.comments.resolved.dialog.message": "此留言永遠不會消失！您可以隨時查看已解決的留言。",
  "inline.comments.resolved.dialog.show.me": "展示",
  "inline.comments.resolved.discovery.button.dismiss": "好的，明白了",
  "inline.comments.resolved.discovery.content": "還有更多話想說嗎？您可以重新開啟已解決的留言以繼續討論。",
  "inline.comments.resolved.menu.show.replies": "{0} 個回覆",
  "inline.comments.resolved.menu.show.reply": "{0} 回覆",
  "inline.comments.resolved.menu.unresolve": "重新開啟",
  "inline.comments.resolved.message": "解決者為：{0} {1}",
  "inline.comments.resolved.view.menu": "已解決的留言",
  "inline.comments.server.edit.error": "我們無法儲存您的編輯內容。此留言可能已遭刪除。",
  "inline.comments.server.error": "無法完成您的要求。",
  "inline.comments.server.error.edit.comment": "我們無法編輯此留言。此留言可能已遭刪除。",
  "inline.comments.server.error.edit.reply": "我們無法編輯此回覆。此回覆可能已遭刪除。",
  "inline.comments.sidebar.cancel": "取消",
  "inline.comments.sidebar.close": "關閉",
  "inline.comments.sidebar.comment.empty": "您無法儲存空白的留言。",
  "inline.comments.sidebar.delete": "刪除",
  "inline.comments.sidebar.deleted": "已刪除",
  "inline.comments.sidebar.discard": "捨棄",
  "inline.comments.sidebar.edit": "編輯",
  "inline.comments.sidebar.error.create.comment": "我們無法新增您的內嵌留言；您醒目提示的區段可能包含巨集或使用者提及。嘗試醒目顯示純文字。",
  "inline.comments.sidebar.error.delete.generic": "刪除留言時發生錯誤。請檢查 Confluence 記錄來找出錯誤。",
  "inline.comments.sidebar.error.delete.unauthorised": "您沒有足夠的權限來刪除此留言。",
  "inline.comments.sidebar.error.empty": "請輸入留言。",
  "inline.comments.sidebar.error.save.comment": "無法儲存留言",
  "inline.comments.sidebar.error.save.reply": "無法儲存回覆",
  "inline.comments.sidebar.error.stale": "頁面內容已過時，請{0}重新整理{1}，然後再試一次。",
  "inline.comments.sidebar.like": "讚",
  "inline.comments.sidebar.pagecomment.success": "已成功建立頁面留言",
  "inline.comments.sidebar.reply": "回覆",
  "inline.comments.sidebar.resolve": "解決",
  "inline.comments.sidebar.resolved": "已解決",
  "inline.comments.sidebar.save": "儲存",
  "inline.comments.sidebar.saved": "已儲存",
  "inline.comments.sidebar.shortcuts.close.description": "關閉內嵌留言",
  "inline.comments.sidebar.show.resolved.comment": "顯示已解決的留言",
  "inline.comments.sidebar.tooltip.close.description": "關閉側邊欄 (])",
  "inline.comments.sidebar.tooltip.next.ic.description": "下一則留言 (N)",
  "inline.comments.sidebar.tooltip.previous.ic.description": "上一則留言 (P)",
  "inline.comments.templates.create.a.comment": "已在頁面上<strong>留言</strong>",
  "inline.comments.templates.resolved.a.comment": "<strong>已解決</strong>留言",
  "inline.comments.templates.resolved.a.comment.dangling": "已刪除由內嵌留言參照的文字，因此<strong>已解決</strong>此留言",
  "inline.comments.templates.unresolved.a.comment": "<strong>已重新開啟</strong>留言",
  "inline.comments.unresolved.message": "由 {0} {1} 重新開啟",
  "jar.file": "Java 封存",
  "java.file": "Java 來源",
  "jpeg.file": "JPEG 檔案",
  "js.file": "JavaScript 檔案",
  "keyboard.shortcut.alt": "Alt",
  "keyboard.shortcut.ctrl": "Ctrl",
  "keyboard.shortcut.option": "選項",
  "keyboard.shortcut.shift": "Shift",
  "label.contains.invalid.chars": "<b>{0}</b> 包含無效字元 ({1})。",
  "label.name.is.too.long": "標籤名稱必須少於 {0} 個字元。",
  "labels.dialog.shortcut.tip": "快速鍵提示：在頁面檢視中，按下 <b>{shortcut}</b> 也會開啟此對話方塊",
  "labels.none": "無標籤",
  "labels.title": "標籤",
  "last.saved": "上次儲存",
  "likes.bethefirst": "成為第一個對此按讚的人",
  "likes.follow": "追蹤",
  "likes.following": "追蹤中",
  "likes.like": "讚",
  "likes.peoplewholikethis": "對此按讚的人",
  "likes.summary.1.non-promoted": "{0} 對此按讚",
  "likes.summary.1.promoted": "{0} 對此按讚",
  "likes.summary.1.promoted.1.non-promoted": "{0} 與 {1} 對此按讚",
  "likes.summary.2.promoted": "{0} 與 {1} 對此按讚",
  "likes.summary.2.promoted.1.non-promoted": "{0}、{1} 和 {2} 對此按讚",
  "likes.summary.3.promoted": "{0}、{1} 和 {2} 對此按讚",
  "likes.summary.3.promoted.1.non-promoted": "{0}、{1}、{2} 和 {3} 對此按讚",
  "likes.summary.you": "您對此按讚",
  "likes.summary.you.1.non-promoted": "您和 {0} 對此按讚",
  "likes.summary.you.1.promoted": "您和 {0} 對此按讚",
  "likes.summary.you.1.promoted.1.non-promoted": "您、{0} 和 {1} 對此按讚",
  "likes.summary.you.2.promoted": "您、{0} 和 {1} 對此按讚",
  "likes.summary.you.2.promoted.1.non-promoted": "您、{0}、{1} 和 {2} 對此按讚",
  "likes.summary.you.3.promoted": "您、{0}、{1} 和 {2} 對此按讚",
  "likes.summary.you.3.promoted.1.non-promoted": "您、{0}、{1}、{2} 和 {3} 對此按讚",
  "likes.unlike": "收回讚",
  "limited.mode.existing.editor.body": "協同編輯現已離線，而 {0} 正在編輯此頁面。請在數分鐘之後再試一次。",
  "link.browser.advanced.desc1": "若要將連結插入新頁面中，請輸入所需的頁面標題。",
  "link.browser.advanced.desc2": "若要插入錨點連結，請鍵入 #anchorname。",
  "link.browser.advanced.error.internal.error": "發生內部伺服器錯誤",
  "link.browser.advanced.error.not.link": "提供的標記是無效的連結標記",
  "link.browser.advanced.error.unknown.shortcut": "{0} 不是可辨識的快速鍵",
  "link.browser.advanced.error.unknown.space": "{0} 不是可辨識的空間",
  "link.browser.advanced.title": "您可以在此使用 <a href=\"{0}\" target=\"_blank\">Wiki 標記</a>，將連結插入頁面中。",
  "link.browser.autocomplete.hint": "提示：在編輯器中輸入 \"[\" 可查看建議頁面清單並插入連結。",
  "link.browser.cancel.button": "取消",
  "link.browser.edit.button": "插入",
  "link.browser.edit.title": "編輯連結",
  "link.browser.file.attach": "上傳檔案",
  "link.browser.file.attach.desc": "連結至附加至此頁面的檔案或附加新檔案。",
  "link.browser.file.attach.upload.in.progress": "上傳進行中...",
  "link.browser.file.browse.button": "瀏覽",
  "link.browser.files.none": "此頁面上沒有檔案。",
  "link.browser.insert.button": "插入",
  "link.browser.insert.title": "插入連結",
  "link.browser.link": "連結",
  "link.browser.link.alias": "連結文字",
  "link.browser.link.image.label": "連結影像",
  "link.browser.location": "連結位置",
  "link.browser.recently.viewed.load.error": "載入最近檢視的頁面時發生錯誤",
  "link.browser.recently.viewed.none": "您沒有最近檢視過的內容。",
  "link.browser.search": "搜尋",
  "link.browser.search.for": "搜尋",
  "link.browser.search.invalid": "無效的搜尋字詞",
  "link.browser.search.results.load.error": "搜尋期間遇到錯誤。",
  "link.browser.search.results.none": "找不到搜尋結果。",
  "link.browser.space.all": "所有內容",
  "link.browser.tab.name.advanced": "進階",
  "link.browser.tab.name.files": "檔案",
  "link.browser.tab.name.recently.viewed": "最近檢視的項目",
  "link.browser.tab.name.search": "搜尋",
  "link.browser.tab.name.weblinks": "Web 連結",
  "link.browser.table.file.comment": "留言",
  "link.browser.table.file.name": "名稱",
  "link.browser.table.file.size": "大小",
  "link.browser.table.last.modified": "上次修改",
  "link.browser.table.space": "空間",
  "link.browser.table.title": "標題",
  "link.browser.web.link": "URL",
  "link.browser.web.link.desc": "網頁、電子郵件或任何其他網際網路位址",
  "link.browser.web.link.label": "位址",
  "location.name": "位置",
  "login.button": "登入",
  "look.and.feel": "外觀和風格",
  "marketplace.link.name": "Marketplace 應用程式",
  "more.word.action": "更多動作",
  "more.word.capitalised": "更多",
  "moveblogpost.already.exists.in.target.space": "另一個具有相同標題和日期的部落格貼文已存在於選取的空間中。",
  "moveblogpost.source.notfound": "找不到來源部落格貼文。",
  "moveblogpost.target.space.notfound": "找不到目標空間。",
  "moveblogpost.target.space.same.as.origin": "您無法將部落格貼文移至已有該部落格貼文的空間。",
  "multimedia.file": "多媒體檔案",
  "my.drafts.mainBanner": "快速捕捉想法",
  "my.drafts.subBanner": "建立頁面並寫下您的想法。如果您尚未準備好發佈，只要關閉頁面即可。我們會將其自動儲存為草稿，以便您在準備好時繼續。 ",
  "my.spaces.tooltip.add": "新增至我的空間",
  "my.spaces.tooltip.remove": "從我的空間中移除",
  "name.word": "名稱",
  "nav.controller.activity": "活動",
  "nav.controller.activity.feed": "活動摘要",
  "nav.controller.all.spaces": "空間",
  "nav.controller.discover": "探索",
  "nav.controller.my.spaces": "我的空間",
  "nav.controller.my.spaces.anchor": "全部",
  "nav.controller.my.spaces.blank": "將最實用的空間放在手邊。點擊任何空間旁邊的星形圖示，使其出現在這裡。",
  "nav.controller.my.spaces.blank.callToAction": "尋找空間",
  "nav.controller.projects": "專案",
  "nav.controller.recent": "最近使用的頁面",
  "nav.controller.your.work": "您的工作",
  "navigation.app.switcher.apps": "應用程式",
  "navigation.app.switcher.dont.show.again": "不要再顯示",
  "navigation.app.switcher.edit": "編輯",
  "navigation.app.switcher.error-message": "取得應用程式連結時發生錯誤。",
  "navigation.app.switcher.home.description": "首頁",
  "navigation.app.switcher.img.alt": "應用程式切換器",
  "navigation.app.switcher.loading": "正在載入...",
  "navigation.app.switcher.recent": "最近檢視過的項目",
  "navigation.app.switcher.recent-containers-confluence-space": "空間",
  "navigation.app.switcher.recent-containers-jira-project": "專案",
  "navigation.app.switcher.try.other.apps": "嘗試其他應用程式",
  "navigation.app.switcher.use.confluence": "使用 Confluence",
  "navigation.app.switcher.use.jira": "使用 Jira",
  "navigation.label-for-bell": "通知",
  "navigation.label-for-global-people-icon": "人員名錄",
  "navigation.notification-drawer-title": "首頁通知",
  "navigation.people-drawer-title": "人員名錄",
  "navlink.edit": "{0}編輯{1}",
  "network.page": "網路頁面",
  "no.drafts.found": "找不到草稿",
  "no.matches.mainBanner": "我們找不到以下的任何項目",
  "no.name": "沒有",
  "no.permission": "沒有權限",
  "no.spaces.found": "找不到空間。",
  "not.watching.anything": "您未追蹤任何項目。",
  "notification.start": "開始追蹤",
  "notification.stop": "停止追蹤",
  "notifications.batch.inline.comment.created.section.header": "{0, choice, 1#內嵌留言|1<內嵌留言}",
  "notifications.batch.inline.comment.new.lozenge": "全新",
  "notifications.batch.inline.comment.reopened.lozenge": "已重新開啟",
  "notifications.batch.inline.comment.resolved": "$user $lozenge 留言",
  "notifications.batch.inline.comment.resolved.lozenge": "已解決",
  "notifications.preferences.desc": "您可以在<a href=\"viewmyemailsettings.action\">電子郵件設定</a>頁面上設定電子郵件通知選項。",
  "onboarding-choose-a-space.description": "從您團隊的其中一個目前空間中進行選擇。您稍後就能建立更多空間。",
  "onboarding-choose-a-space.title": "選擇一個工作空間",
  "onboarding.choose-a-space.backBtn": "返回",
  "onboarding.choose-a-space.nextBtn": "下一步",
  "onboarding.choose-a-space.selectLabel": "空間名稱",
  "onboarding.choose-a-space.selectPlaceholder": "選取空間名稱",
  "onboarding.create-a-space.backBtn": "上一步",
  "onboarding.create-a-space.description": "從您目前團隊或專案的空間開始。您稍後能夠建立更多空間。",
  "onboarding.create-a-space.inputTextLabel": "名稱",
  "onboarding.create-a-space.inputTextPlaceholder": "水晶寶石",
  "onboarding.create-a-space.invalidMessage": "空間名稱必須包含至少一個字母或數字。",
  "onboarding.create-a-space.nextBtn": "下一步",
  "onboarding.create-a-space.title": "建立一個工作空間",
  "onboarding.dialog.existing-user.cancel": "不顯示提示",
  "onboarding.dialog.existing-user.confirm": "讓我們開始吧",
  "onboarding.dialog.existing-user.content": "我們已移動一些項目來讓您擁有更好的儀表板體驗，並且開啟了一些協助您入門的提示。",
  "onboarding.dialog.existing-user.title": "歡迎使用全新的儀表板！",
  "onboarding.dialog.new-user.cancel": "不顯示提示",
  "onboarding.dialog.new-user.confirm": "讓我們開始吧",
  "onboarding.dialog.new-user.content": "儀表板是可協助您瀏覽 Confluence 的登陸頁面。<br/>我們已開啟一些提示，方便您開始使用",
  "onboarding.dialog.new-user.title": "歡迎使用儀表板！",
  "onboarding.navigation.blog.tip.blog.list.byline": "點擊首頁以切換到頁面清單或其他內容。",
  "onboarding.navigation.blog.tip.blog.list.heading": "您的部落格清單仍可在此找到",
  "onboarding.navigation.dont.show": "不要顯示更多提示",
  "onboarding.navigation.global.sidebar.byline": "因此，無論您位於 Confluence 的何處，只要按一下就可以處理重要事項。",
  "onboarding.navigation.global.sidebar.heading": "此側邊欄現在為通用狀態",
  "onboarding.navigation.ok": "好的，明白了",
  "onboarding.navigation.page.tip.page.tree.byline": "點擊首頁以切換到部落格清單或其他內容。",
  "onboarding.navigation.page.tip.page.tree.heading": "您仍然可以在這裡找到頁面樹狀結構",
  "onboarding.navigation.space.tip.space.tabs.byline": "您的空間首頁現在為概觀，而您的頁面、部落格貼文和其他內容都有自己的分頁。",
  "onboarding.navigation.space.tip.space.tabs.heading": "您的內容現在已整理在分頁中",
  "onboarding.tooltip.actions.done": "我知道了。",
  "onboarding.tooltip.actions.next": "下一頁",
  "onboarding.tooltip.actions.skip": "略過提示",
  "onboarding.tooltip.existing-user.favourite-spaces.content": "直接跳到您最愛的空間，或瀏覽所有空間的清單。",
  "onboarding.tooltip.existing-user.favourite-spaces.title": "最愛的空間唾手可得",
  "onboarding.tooltip.existing-user.sidebar.content": "在可滑動的新側邊欄中尋找新頁面及回到最近的工作。",
  "onboarding.tooltip.existing-user.sidebar.title": "探索更多有關側邊欄的資訊",
  "onboarding.tooltip.new-user.favourite-spaces.content": "直接跳到您最愛的空間，或瀏覽所有空間的清單。",
  "onboarding.tooltip.new-user.favourite-spaces.title": "最愛的空間唾手可得",
  "onboarding.tooltip.new-user.sidebar.content": "從側邊欄尋找新頁面及回到最近的工作。",
  "onboarding.tooltip.new-user.sidebar.title": "探索更多有關側邊欄的資訊",
  "onboarding.tooltip.saved-for-later.content": "您最愛的頁面現在會顯示在其新名稱底下 - 已儲存供稍後使用。",
  "onboarding.tooltip.saved-for-later.title": "告別「我的最愛」功能，迎接「已儲存供稍後使用」功能",
  "onboarding.who-is-on-your-team.addMoreBtn": "+ 新增更多電子郵件",
  "onboarding.who-is-on-your-team.description": "當團隊成員與您建立、討論及協作時，Confluence 表現比較好。",
  "onboarding.who-is-on-your-team.emailPlaceholder": "新增電子郵件地址",
  "onboarding.who-is-on-your-team.enableDRS": "讓擁有經驗證 {domain} 電子郵件地址的任何人加入您的網站 (每次發生此情況時，我們都會通知您)。",
  "onboarding.who-is-on-your-team.enableOpenInvite": "讓使用者邀請其他人員前往您的網站。",
  "onboarding.who-is-on-your-team.form.invalid.email": "請輸入有效的電子郵件",
  "onboarding.who-is-on-your-team.nextBtn": "下一步",
  "onboarding.who-is-on-your-team.title": "您的團隊成員有哪些人？",
  "only.personal.labels.permitted": "您只能在此頁面上新增個人標籤。",
  "org.randombits.confluence.toc.toc.label": "目錄",
  "page.already.exists": "另一個具有相同標題的頁面已存在於選取的空間中。",
  "page.already.exists.inspace": "該頁面 '{'0'}' 已存在於 '{'1'}' 空間。您需要重新命名頁面標題，才能將其移動。",
  "page.change": "您變更了什麼？",
  "page.comments.saved.dialog.message": "您的留言已儲存為頁面留言。",
  "page.comments.sidebar.warning": "我們無法在此內容中新增內嵌留言。我們會改為將其新增為頁面留言。",
  "page.descendent.already.exists": "子系頁面會共用所選空間中另一個頁面的相同標題。",
  "page.permissions.menu.item.title": "限制",
  "page.permissions.menu.item.title.tooltip": "編輯限制",
  "page.tree.blankExperience.mainBanner": "這裡目前什麼都沒有，只有潛力無限。",
  "page.tree.blankExperience.subBanner": "建立一些會議記錄、產品要求、操作說明文章或其他內容，查看此空間是否已填滿。",
  "page.watch.instruction": "若要追蹤頁面或部落格貼文：開啟「工具」選單，然後按一下「追蹤」。",
  "page.watches": "追蹤的頁面",
  "page.word": "頁面",
  "pages.navigation.discovery.body.html": "按一下「<strong>頁面</strong>」以顯示頁面樹狀結構，並瀏覽此空間中的頁面。",
  "pages.navigation.discovery.header": "頁面樹狀結構現在存留在此處",
  "pages.show.all": "顯示所有頁面",
  "pages.word": "頁面",
  "pagetree.dragndrop.failed.action.visitsupport": "造訪 Atlassian 支援",
  "pagetree.dragndrop.failed.description": "請重新整理頁面，然後再試一次。如果這種狀況持續發生，請使用下方連結讓我們知道。",
  "pagetree.dragndrop.failed.title": "發生錯誤。",
  "pagetree.failed.load.content": "無法載入頁面樹狀結構",
  "pagetree.failed.load.tooltip": "請再等一下，我們正在努力解決此問題。",
  "parent.page.invalid.for.space": "<b>{1}</b> 空間中沒有標題為 <b>{0}</b> 的頁面。",
  "parent.page.name": "父系頁面",
  "pdf.file": "PDF 檔案",
  "people.directory.name": "人員",
  "period.lastSevenDays": "過去一週內",
  "period.lastThirtyDays": "在上個月",
  "period.older": "一個多月前",
  "period.today": "今天",
  "period.yesterday": "昨天",
  "permission.owner.not.in.group": "您只能將頁面權限授予您所屬的群組",
  "permission.owner.not.set": "您必須選擇此權限的負責人",
  "permissions.comment": "定義可以檢視和編輯頁面的人員。您可以將這些權限限制為您自己或一組使用者。",
  "permissions.edit.title": "編輯",
  "permissions.select.nopermissions": "未設定",
  "permissions.view.title": "檢視",
  "person.follow": "追蹤",
  "person.follow.stop": "停止追蹤",
  "personal.spaces": "個人空間",
  "placeholder.placeholdertext.label": "預留位置文字",
  "placeholder.replacementtext.label": "取代文字",
  "please.enter.a.label": "請輸入標籤",
  "png.file": "PNG 檔案",
  "popular.stream.mainBanner": "沒有發生太多事情... 然而",
  "popular.stream.subBanner": "現在的情況相當平靜，但一旦團隊開始建立，最熱門的頁面和檔案將出現在此處。",
  "popular.stream.subBanner2": "讓我們開始這場派對吧！",
  "popular.stream.title": "熱門",
  "posted.word": "已張貼",
  "powerpoint.file": "Microsoft Powerpoint 簡報",
  "powerpoint.macro.file": "Microsoft Powerpoint 已啟用巨集的簡報",
  "powerpoint.slideshow.file": "Microsoft Powerpoint 投影片",
  "powerpoint.template.file": "Microsoft Powerpoint 範本",
  "powerpoint97.file": "Microsoft Powerpoint 97 投影片",
  "powerpoint97.template.file": "Microsoft Powerpoint 97 範本",
  "product.name": "Confluence",
  "profile.page": "個人檔案頁面",
  "property.panel.macro.display.inline": "顯示內嵌",
  "property.panel.macro.display.newline": "在新的一行上顯示",
  "property.panel.macro.edit": "編輯",
  "property.panel.macro.remove": "移除",
  "property.panel.textplaceholder.display.default": "文字",
  "property.panel.textplaceholder.display.default.tooltip": "當有人輸入時，指示性文字會取代為空白內容。",
  "property.panel.textplaceholder.display.mention": "使用者提及",
  "property.panel.textplaceholder.display.mention.tooltip": "當人員在鍵入時，指示性文字會被替換成建議的人員。",
  "property.panel.textplaceholder.remove": "移除",
  "property.panel.variable.display.list": "清單",
  "property.panel.variable.display.list.tooltip": "下拉式清單。",
  "property.panel.variable.display.string": "文字",
  "property.panel.variable.display.string.tooltip": "單行文字輸入欄位。",
  "property.panel.variable.display.textarea": "多行文字",
  "property.panel.variable.display.textarea.tooltip": "多行文字輸入欄位。",
  "property.panel.variable.list.values.tooltip": "輸入清單中的每個項目，並以逗號分隔每個項目。",
  "property.panel.variable.textarea.columns.tooltip": "要針對此欄位顯示的欄數。",
  "property.panel.variable.textarea.rows.tooltip": "要針對此欄位顯示的列數。",
  "quick.comment.placeholder.message": "撰寫留言...",
  "quick.reload.edit": "新的頁面編輯",
  "quick.reload.edit.by": "由",
  "quick.reload.edit.more": "和其他 {0} 個",
  "quick.reload.edit.one.more": "和其他 1 個",
  "quick.reload.edits": "{0} 項新的編輯項目",
  "quick.reload.newcomments": "{0} 個新留言",
  "quick.reload.newpagecomment": "新留言",
  "quick.reload.reload": "重新載入頁面",
  "recently-updated-content-list.commented.new": "留言時間：{time}",
  "recently-updated-content-list.created.new": "建立時間：{time}",
  "recently-updated-content-list.edited.new": "更新時間：{time}",
  "recently.viewed.mainBanner": "創造歷史的時刻",
  "recently.viewed.subBanner": "您尚未造訪過任何頁面，但是當您這麼做時，我們會將其放在此處，以便您快速返回。",
  "recently.viewed.subBanner2": "立即前往並參觀<b>空間</b>。",
  "recently.viewed.title": "最近造訪",
  "recently.worked.mainBanner": "完成該傑作",
  "recently.worked.subBanner": "您尚未建立或編輯任何內容，但是當您這麼做時，我們會將其放在這裡，讓您輕鬆地從上次離開的地方繼續。",
  "recently.worked.subBanner2": "現在就開始建立最棒的工作吧。",
  "recently.worked.title": "最近處理",
  "remove.comment.confirmation.message": "您確定要刪除留言嗎？",
  "remove.label": "刪除標籤",
  "resize.image.dialog.title": "重新調整影像大小",
  "restore.this.version": "還原此版本",
  "result.grid.column.content.last.modified": "上次修改",
  "resume.editing": "繼續",
  "return.to.page.info": "返回頁面資訊",
  "satisfaction.survey.reaction.amazing": "了不起",
  "satisfaction.survey.reaction.bad": "不佳",
  "satisfaction.survey.reaction.great": "太棒了",
  "satisfaction.survey.reaction.okay": "確定",
  "satisfaction.survey.reaction.terrible": "糟糕",
  "save.name": "儲存",
  "scheme.desc.custom": "可編輯的自訂色彩配置。",
  "scheme.desc.global": "此色彩配置將對此空間使用全域定義的色彩配置。",
  "scheme.title.custom": "自訂顏色配置",
  "scheme.title.global": "全域顏色配置",
  "search.drawer.recently.viewed": "最近檢視的項目",
  "search.drawer.recently.viewed.spaces": "最近存取的空間",
  "search.name": "搜尋",
  "settings.name": "設定",
  "share.button.restriction.message.text": "此頁面上的限制可能會導致使用者無法檢視或編輯",
  "share.button.text": "分享",
  "show.more.blogposts": "顯示更多部落格貼文",
  "sidebar.avatar.picker.upload.error": "更新空間詳細資料時發生錯誤。",
  "sidebar.main.back.to.overview": "返回概觀",
  "sidebar.main.back.to.space": "返回空間",
  "sidebar.main.blog": "部落格",
  "sidebar.main.quick.links": "空間捷徑",
  "sidebar.main.settings": "空間設定",
  "sidebar.main.shortcuts": "連結",
  "sidebar.main.wiki": "頁面",
  "site-settings.templates-and-blueprints.edit-button-label": "編輯",
  "space.404.banner.title": "哎呀，您找到一個無效連結",
  "space.404.go.back": "返回",
  "space.404.go.to": "請前往",
  "space.404.home.page": "首頁",
  "space.404.previous.page": "上一頁",
  "space.create": "建立空間",
  "space.home.blog.blankExperience.mainBanner": "有什麼要分享的嗎？",
  "space.home.blog.blankExperience.subBanner": "部落格貼文是與團隊分享公告、狀態報告或其他重要消息的絕佳方式。",
  "space.home.overview.blankExperience.mainBanner": "嗯，這有點奇怪。",
  "space.home.overview.blankExperience.subBanner": "此空間沒有首頁，所以沒有可在此顯示的內容。這真令人難過。",
  "space.home.overview.blankExperience.subBanner2": "現在新增首頁來進行整理，並將其用於告知造訪者這個空間的相關資訊！",
  "space.not.exists": "您指定的空間不存在。",
  "space.personal.name": "個人空間",
  "space.set.space.home": "設定空間首頁",
  "space.watch.instruction": "若要追蹤空間中的網頁或部落格貼文，請按一下空間側邊欄中的「頁面」或「部落格」。",
  "space.watches": "空間追蹤",
  "spaces.all": "所有空間",
  "spaces.lookandfeel.help": "您可以在這裡自訂此 Confluence 空間的外觀。",
  "spaces.lookandfeel.note": "<span class=\"errorMessage\">注意：</span><i>此處完成的任何修改都將覆寫管理員設定的預設顏色配置和預設裝飾項目。</i>",
  "spaces.word": "空間",
  "starred.mainBanner": "這裡看不到任何資料... 然而",
  "starred.spaces.tooltip.add": "為此空間標上星號",
  "starred.spaces.tooltip.remove": "移除此空間的星號",
  "starred.subBanner": "點擊<b>星形圖示</b>，以儲存頁面供日後使用。我們會將其放在這裡，以便您在需要時找到它。",
  "starred.title": "已儲存供稍後使用",
  "status.lozenge.draft": "草稿",
  "status.lozenge.unpublished": "未發佈的變更",
  "submit.name": "提交",
  "super-admin.banner.exit": "停止使用管理員金鑰",
  "super-admin.banner.message": "您使用的是管理員金鑰，可讓您暫時存取受限制的內容。",
  "switch.apps": "切換應用程式",
  "system.help.legal": "法律",
  "team.create.flag.error.description": "我們無法為您建立團隊。請稍後再試一次",
  "team.create.flag.error.title": "糟糕！發生錯誤。",
  "team.created.flag.description": "{membersCount, plural, other {您已邀請 {membersCount} 個人加入 '{'teamName'}' 團隊}}",
  "team.created.flag.title": "已建立新團隊",
  "team.created.flag.view": "檢視團隊",
  "template.variables.fabric.section.message": "此範本會使用變數。填入變數後，您提供的資訊將成為新頁面內容的一部分。",
  "templates.name": "範本",
  "text.file": "文字檔案",
  "text.selected": "已選取",
  "tinymce.advanced.block": "格式",
  "tinymce.advanced.blockquote": "引述",
  "tinymce.advanced.blockquote_shortcut": "Ctrl+8",
  "tinymce.advanced.bold_desc": "粗體",
  "tinymce.advanced.bold_shortcut": "Ctrl+B",
  "tinymce.advanced.bullist_desc": "項目符號清單",
  "tinymce.advanced.bullist_shortcut": "Ctrl+Shift+B",
  "tinymce.advanced.charmap_desc": "符號",
  "tinymce.advanced.forecolor_desc": "選取文字顏色",
  "tinymce.advanced.formatting_desc": "格式設定",
  "tinymce.advanced.h1": "標題 1",
  "tinymce.advanced.h1_shortcut": "Ctrl+1",
  "tinymce.advanced.h2": "標題 2",
  "tinymce.advanced.h2_shortcut": "Ctrl+2",
  "tinymce.advanced.h3": "標題 3",
  "tinymce.advanced.h3_shortcut": "Ctrl+3",
  "tinymce.advanced.h4": "標題 4",
  "tinymce.advanced.h4_shortcut": "Ctrl+4",
  "tinymce.advanced.h5": "標題 5",
  "tinymce.advanced.h5_shortcut": "Ctrl+5",
  "tinymce.advanced.h6": "標題 6",
  "tinymce.advanced.h6_shortcut": "Ctrl+6",
  "tinymce.advanced.headings": "標題 1 到 6",
  "tinymce.advanced.headings_shortcut": "Ctrl+1..6",
  "tinymce.advanced.hr_desc": "水平尺規",
  "tinymce.advanced.indent_desc": "增加縮排",
  "tinymce.advanced.italic_desc": "斜體",
  "tinymce.advanced.italic_shortcut": "Ctrl+I",
  "tinymce.advanced.justifycenter_desc": "置中對齊",
  "tinymce.advanced.justifyfull_desc": "完全對齊",
  "tinymce.advanced.justifyleft_desc": "靠左對齊",
  "tinymce.advanced.justifyright_desc": "靠右對齊",
  "tinymce.advanced.numlist_desc": "編號清單",
  "tinymce.advanced.numlist_shortcut": "Ctrl+Shift+N",
  "tinymce.advanced.outdent_desc": "減少縮排",
  "tinymce.advanced.paragraph": "段落",
  "tinymce.advanced.paragraph_shortcut": "Ctrl+0",
  "tinymce.advanced.pre": "預設格式",
  "tinymce.advanced.pre_shortcut": "Ctrl+7",
  "tinymce.advanced.redo_desc": "重做",
  "tinymce.advanced.redo_shortcut": "Ctrl+Y",
  "tinymce.advanced.striketrough_desc": "刪除線",
  "tinymce.advanced.striketrough_shortcut": "Ctrl+Shift+S",
  "tinymce.advanced.sub_desc": "下標",
  "tinymce.advanced.sup_desc": "上標",
  "tinymce.advanced.tasklist_desc": "任務清單",
  "tinymce.advanced.tasklist_shortcut": "[然後]",
  "tinymce.advanced.underline_desc": "底線",
  "tinymce.advanced.underline_shortcut": "Ctrl+U",
  "tinymce.advanced.undo_desc": "復原",
  "tinymce.advanced.undo_shortcut": "Ctrl+Z",
  "tinymce.advanced.unlink_desc": "取消連結",
  "tinymce.atlassian.help": "說明",
  "tinymce.atlassian.insert_menu": "插入",
  "tinymce.atlassian.insert_menu.charmap_desc": "插入符號",
  "tinymce.atlassian.insert_menu.content_desc": "插入內容",
  "tinymce.atlassian.insert_menu.hr_desc": "插入水平尺規 (----)",
  "tinymce.atlassian.insert_menu.macro_desc": "插入巨集",
  "tinymce.atlassian.insert_menu.tooltip": "插入更多內容",
  "tinymce.atlassian.monospace": "等寬",
  "tinymce.atlassian.monospace_desc": "使用等寬字型來格式化文字",
  "tinymce.atlassian.more_menu": "更多",
  "tinymce.atlassian.remove_formatting": "清除格式",
  "tinymce.atlassian.remove_formatting_desc": "清除目前所選文字上的格式",
  "tinymce.auiwindowmanager.cancel": "取消",
  "tinymce.auiwindowmanager.ok": "確定",
  "tinymce.autocomplete.web.resource.name": "Confluence 自動完成 Web 資源",
  "tinymce.autocomplete.web.resource.only.name": "Confluence 自動完成沒有相依性的 Web 資源",
  "tinymce.charmap.web.resource.name": "TinyMce 字元對應 Web 資源",
  "tinymce.charmap_dlg.title": "插入符號",
  "tinymce.colorpicker.color": "顏色",
  "tinymce.colorpicker.more_colors": "更多顏色",
  "tinymce.colorpicker.picker_tab": "選擇器",
  "tinymce.colorpicker.picker_title": "顏色選擇器",
  "tinymce.colorpicker.title": "選取顏色",
  "tinymce.colorpicker.web.resource.name": "Confluence 顏色選擇器 Web 資源",
  "tinymce.confluence.conf_emoji": "表情符號",
  "tinymce.confluence.conf_emoticon": "表情符號",
  "tinymce.confluence.conf_emoticon_desc": "插入表情符號",
  "tinymce.confluence.conf_file": "檔案和影像",
  "tinymce.confluence.conf_file_desc": "插入檔案和影像",
  "tinymce.confluence.conf_file_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_image": "影像",
  "tinymce.confluence.conf_image_desc": "插入影像",
  "tinymce.confluence.conf_image_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_link": "連結",
  "tinymce.confluence.conf_link_desc": "插入連結",
  "tinymce.confluence.conf_link_shortcut": "Ctrl+K",
  "tinymce.confluence.conf_macro_browser": "巨集",
  "tinymce.confluence.conf_macro_browser_desc": "插入巨集",
  "tinymce.confluence.conf_macro_browser_shortcut": "Ctrl+Shift+A",
  "tinymce.confluence.conf_media": "影像/媒體",
  "tinymce.confluence.conf_other_macros_desc": "其他巨集...",
  "tinymce.confluence.conf_shortcuts_help": "鍵盤快速鍵說明",
  "tinymce.confluence.conf_tasklist": "任務清單",
  "tinymce.confluence.conf_tasklist_desc": "插入任務清單",
  "tinymce.confluence.conf_tasklist_shortcut": "[然後]",
  "tinymce.confluence.conf_widget_desc": "小工具",
  "tinymce.confluence.conf_wikimarkup": "標記",
  "tinymce.confluence.conf_wikimarkup.insert.label": "插入",
  "tinymce.confluence.conf_wikimarkup_confluence_label": "Confluence wiki",
  "tinymce.confluence.conf_wikimarkup_conversion_errors": "Wiki 標記轉換錯誤",
  "tinymce.confluence.conf_wikimarkup_desc": "插入標記",
  "tinymce.confluence.conf_wikimarkup_hint": "提示：您也可以直接在編輯器中輸入 Wiki 標記，其會在您輸入時進行格式設定。",
  "tinymce.confluence.conf_wikimarkup_info_title": " 在下面輸入 Wiki 標記或 Markdown。Confluence 會將內容轉換為編輯器格式，並將其插入頁面。",
  "tinymce.confluence.conf_wikimarkup_markdown_label": "Markdown",
  "tinymce.confluence.conf_wikimarkup_preview_label": "預覽",
  "tinymce.confluence.conf_wikimarkup_shortcut": "Ctrl+Shift+D",
  "tinymce.confluence.conf_wikimarkup_timeout": "伺服器花費太長的時間來轉換 Wiki 標記。這可能只是暫時性問題，所以您可再試一次。",
  "tinymce.confluence.files": "檔案",
  "tinymce.confluence.help_desc": "說明",
  "tinymce.confluence.htmlsource": "來源",
  "tinymce.confluence.htmlsource_desc": "檢視 HTML 來源",
  "tinymce.confluence.layout.menu": "頁面版面配置",
  "tinymce.confluence.layout.none": "無版面配置",
  "tinymce.confluence.layout.three_col": "三欄",
  "tinymce.confluence.layout.three_col_sidebars": "三欄 (左側邊欄和右側邊欄)",
  "tinymce.confluence.layout.three_col_simple": "三欄 (簡單)",
  "tinymce.confluence.layout.two_col": "兩欄",
  "tinymce.confluence.layout.two_col_left": "兩欄 (左側邊欄)",
  "tinymce.confluence.layout.two_col_right": "兩欄 (右側邊欄)",
  "tinymce.confluence.layout.two_col_simple": "兩欄 (簡單)",
  "tinymce.confluence.layout.two_col_simple_left": "兩欄 (簡單、左側邊欄)",
  "tinymce.confluence.layout.two_col_simple_right": "兩欄 (簡單、右側邊欄)",
  "tinymce.confluence.macro_insert": "插入 '{'0'}' 巨集",
  "tinymce.confluence.macro_other": "其他巨集",
  "tinymce.confluence.macro_other_desc": "開啟巨集瀏覽器",
  "tinymce.confluence.placeholder.inline.tasks": "在此輸入任務、使用 \"@\" 來指派給使用者，然後使用 \"//\" 選取截止日期",
  "tinymce.confluence.preview": "預覽",
  "tinymce.confluence.preview_shortcut": "Ctrl+Shift+E",
  "tinymce.confluence.save_shortcut": "Ctrl+S",
  "tinymce.confluence.settings_desc": "編輯器設定",
  "tinymce.confluence_dlg.insertbutton.title": "插入",
  "tinymce.confluence_dlg.insertimage.title": "插入影像",
  "tinymce.confluence_dlg.insertlink.title": "插入連結",
  "tinymce.emotions.emotions_desc": "表情符號",
  "tinymce.emotions.web.resource.name": "TinyMce 表情符號網路資源",
  "tinymce.emotions_dlg.add": "加號 (+)",
  "tinymce.emotions_dlg.biggrin": "大笑 :D",
  "tinymce.emotions_dlg.broken_heart": "心碎 </3",
  "tinymce.emotions_dlg.check": "勾號 (/)",
  "tinymce.emotions_dlg.desc": "表情符號",
  "tinymce.emotions_dlg.error": "錯誤 (x)",
  "tinymce.emotions_dlg.forbidden": "減號 (-)",
  "tinymce.emotions_dlg.heart": "愛心 <3",
  "tinymce.emotions_dlg.help_16": "問號 (?)",
  "tinymce.emotions_dlg.information": "資訊 (i)",
  "tinymce.emotions_dlg.lightbulb": "燈泡暗掉 (off)",
  "tinymce.emotions_dlg.lightbulb_on": "燈泡開啟 (on)",
  "tinymce.emotions_dlg.sad": "悲傷 :(",
  "tinymce.emotions_dlg.smile": "微笑 :)",
  "tinymce.emotions_dlg.star_blue": "藍色星星 (*b)",
  "tinymce.emotions_dlg.star_green": "綠色星號 (*g)",
  "tinymce.emotions_dlg.star_red": "紅色星號 (*r)",
  "tinymce.emotions_dlg.star_yellow": "黃色星星 (*y)",
  "tinymce.emotions_dlg.thumbs_down": "不讚同 (n)",
  "tinymce.emotions_dlg.thumbs_up": "比讚 (y)",
  "tinymce.emotions_dlg.title": "插入表情符號",
  "tinymce.emotions_dlg.tongue": "舌頭 :P",
  "tinymce.emotions_dlg.warning": "警告 (!)",
  "tinymce.emotions_dlg.wink": "眨眼 ;)",
  "tinymce.fabric.migration.dialog.action": "繼續編輯",
  "tinymce.fabric.migration.dialog.content": "別擔心，您的變更不會遺失。我們只需要更新您的頁面。",
  "tinymce.fabric.migration.dialog.title": "我們剛才更新了您的編輯體驗",
  "tinymce.formatting.paragraph": "一般文字",
  "tinymce.full_screen.toolbar_item": "全螢幕",
  "tinymce.full_screen.toolbar_item_title": "以全螢幕模式啟動編輯器",
  "tinymce.hints.autoformat.code": "提示：鍵入 \"<strong>'{{'code'}}'</strong>\" 可快速插入等寬文字。",
  "tinymce.hints.autoformat.heading1": "提示：輸入 \"<strong>h1. Title</strong>\" 可快速插入標題 1。",
  "tinymce.hints.autoformat.heading3": "提示：輸入 \"<strong>h3. Title</strong>\" 可快速插入標題 3。",
  "tinymce.hints.dnd": "提示：您可以直接將電腦中的影像和 Office 檔案拖放到此編輯器中。",
  "tinymce.hints.drafts": "提示：Confluence 會自動儲存草稿。如果您曾遺失視窗，請從「使用者名稱 -> 草稿」功能表復原您的工作。",
  "tinymce.hints.insert.bullet.list": "提示：按下 <strong>Ctrl+Shift+B</strong> 可啟動項目符號清單。",
  "tinymce.hints.insert.heading": "提示：按 <strong>Ctrl+1</strong> 可建立標題層級 1，按 <strong>Ctrl+2</strong> 可建立標題層級 2，依此類推。",
  "tinymce.hints.insert.image": "提示：按下 <strong>Ctrl+M</strong> 可開啟影像瀏覽器。",
  "tinymce.hints.insert.image.end": "提示：在一個字之後按 <strong>Ctrl+Shift+M</strong> 可尋找並插入相關影像。",
  "tinymce.hints.insert.image.on.page": "提示：輸入 \"<strong>！</strong>\" 可查看附加到頁面的影像並插入其中一個影像。",
  "tinymce.hints.insert.image.search": "提示：類型 \"<strong>!</strong>\" 和影像名稱的一部分來尋找並插入影像。",
  "tinymce.hints.insert.link": "提示：按下 <strong>Ctrl+K</strong> 可開啟連結瀏覽器。",
  "tinymce.hints.insert.link.end": "提示：在一個字後按 <strong>Ctrl+Shift+K</strong> 鍵可尋找並連結至相關頁面。再按一次以取得更多建議。",
  "tinymce.hints.insert.link.newpage": "提示：鍵入 \"<strong>[</strong>\" 和您想要建立的新頁面標題，即可看到插入連結建議。",
  "tinymce.hints.insert.link.recently.viewed": "提示：輸入 \"<strong>[</strong>\" 可查看建議頁面清單並插入連結。",
  "tinymce.hints.insert.link.search": "提示：鍵入 \"<strong>[</strong>\" 和頁面標題的一部分可尋找並連結到該頁面。",
  "tinymce.hints.insert.link.user.mention": "提示：輸入 \"<strong>@</strong>\" 並且在後面加上人名，即可在 Confluence 中提及某個人。",
  "tinymce.hints.insert.macro": "提示：按下 <strong>Ctrl+Shift+A</strong> 可開啟巨集瀏覽器。",
  "tinymce.hints.insert.macro.toc": "提示：讓 Confluence 為您產生此頁面的目錄。使用「插入 -> 目錄」",
  "tinymce.hints.insert.newline": "提示：輸入 <strong>Shift+Enter</strong> 可插入不含間距的新段落",
  "tinymce.hints.insert.numbered.list": "提示：按下 <strong>Ctrl+Shift+N</strong> 可啟動編號清單。",
  "tinymce.hints.insert.table": "提示：按下 <strong>Ctrl+Shift+I</strong> 可插入表格。",
  "tinymce.hints.insert.wikimarkup": "提示：編輯器會在您輸入資料時自動轉換 wiki 標記。",
  "tinymce.hints.insert.wikimarkup.dialog": "提示：按下 <strong>Ctrl+Shift+D</strong> 可開啟 Wiki 標記對話方塊。",
  "tinymce.hints.table.rows.copy": "提示：按下 <strong>Ctrl+Shift+C</strong> 可複製一列，而按下 <strong>Ctrl+Shift+V</strong> 可在表格中貼上一列。",
  "tinymce.hints.table.rows.cut": "提示：按下 <strong>Ctrl+Shift+X</strong> 可剪下一列，而按下 <strong>Ctrl+Shift+V</strong> 可在表格中貼上一列。",
  "tinymce.macro.preview.exception": "預覽巨集時發生例外狀況。例外狀況：{0}",
  "tinymce.macro.unknownMacro": "巨集 '{'0'}' 不明。其可能已經從系統中移除。",
  "tinymce.popup_blocked": "此瀏覽器已封鎖編輯器所開啟的快顯視窗。",
  "tinymce.propertypanel.images.border": "邊界",
  "tinymce.propertypanel.images.border.tooltip": "顯示影像周圍的邊框",
  "tinymce.propertypanel.images.large": "大",
  "tinymce.propertypanel.images.large.tooltip": "將影像大小調整為大並連結至原始影像",
  "tinymce.propertypanel.images.link.create": "連結",
  "tinymce.propertypanel.images.link.create.tooltip": "將此影像連結至其他內容",
  "tinymce.propertypanel.images.link.edit": "編輯連結",
  "tinymce.propertypanel.images.link.edit.tooltip": "編輯此影像的連結",
  "tinymce.propertypanel.images.link.remove": "取消連結",
  "tinymce.propertypanel.images.link.remove.tooltip": "移除此影像的連結",
  "tinymce.propertypanel.images.medium": "中",
  "tinymce.propertypanel.images.medium.tooltip": "將影像大小調整為中並連結至原始影像",
  "tinymce.propertypanel.images.original": "原始",
  "tinymce.propertypanel.images.original.tooltip": "將影像大小重設為原始",
  "tinymce.propertypanel.images.sizing.tooltip": "將影像大小調整為特定寬度",
  "tinymce.propertypanel.images.small": "小",
  "tinymce.propertypanel.images.small.tooltip": "將影像大小重新調整為小並連結至原始影像",
  "tinymce.propertypanel.links.edit": "編輯",
  "tinymce.propertypanel.links.edit.tooltip": "編輯對話方塊中的連結",
  "tinymce.propertypanel.links.goto": "前往連結",
  "tinymce.propertypanel.links.goto.disabled.tooltip": "此連結會前往您所編輯頁面上的內容",
  "tinymce.propertypanel.links.unlink": "取消連結",
  "tinymce.propertypanel.links.unlink.tooltip": "以連結中包含的文字取代連結",
  "tinymce.searchreplace.replace_desc": "尋找/取代",
  "tinymce.searchreplace.search_desc": "尋找",
  "tinymce.searchreplace_dlg.allreplaced.plural": "{0} 取代已完成",
  "tinymce.searchreplace_dlg.allreplaced.singular": "1 項取代已完成",
  "tinymce.searchreplace_dlg.close": "關閉",
  "tinymce.searchreplace_dlg.direction": "方向",
  "tinymce.searchreplace_dlg.down": "向下",
  "tinymce.searchreplace_dlg.findlabel": "尋找",
  "tinymce.searchreplace_dlg.findnext": "下一步",
  "tinymce.searchreplace_dlg.findprevious": "上一頁",
  "tinymce.searchreplace_dlg.findwhat": "尋找什麼",
  "tinymce.searchreplace_dlg.mcase": "大小寫相符",
  "tinymce.searchreplace_dlg.notfound": "未取代任何項目",
  "tinymce.searchreplace_dlg.replace": "取代",
  "tinymce.searchreplace_dlg.replace_title": "尋找/取代",
  "tinymce.searchreplace_dlg.replaceall": "全部取代",
  "tinymce.searchreplace_dlg.replacelabel": "取代",
  "tinymce.searchreplace_dlg.search_title": "尋找",
  "tinymce.searchreplace_dlg.searchnext_desc": "再次尋找",
  "tinymce.searchreplace_dlg.up": "向上",
  "tinymce.style.show-eol-markers": "¶",
  "tinymce.style.show-eol-markers.title": "顯示/隱藏行結束標記",
  "tinymce.table": "表格",
  "tinymce.table.cell": "儲存格",
  "tinymce.table.col": "欄",
  "tinymce.table.col_after_desc": "在此項目後面插入欄：",
  "tinymce.table.col_after_desc_shortcut_mac": "Control+Option+→",
  "tinymce.table.col_after_desc_shortcut_win": "Alt+Shift+→",
  "tinymce.table.col_before_desc": "在前面插入欄：",
  "tinymce.table.col_before_desc_shortcut_mac": "Control+Option+←",
  "tinymce.table.col_before_desc_shortcut_win": "Alt+Shift+←",
  "tinymce.table.col_copy_desc": "複製表格欄",
  "tinymce.table.col_cut_desc": "剪下表格欄",
  "tinymce.table.col_highlight": "標題欄",
  "tinymce.table.col_paste_desc": "貼上表格欄",
  "tinymce.table.copy_row_desc": "複製表格列",
  "tinymce.table.copy_row_shortcut": "Ctrl+Shift+C",
  "tinymce.table.cut_row_desc": "剪下表格列",
  "tinymce.table.cut_row_shortcut": "Ctrl+Shift+X",
  "tinymce.table.del": "移除表格",
  "tinymce.table.delete_col_desc": "移除欄",
  "tinymce.table.delete_row_desc": "移除列",
  "tinymce.table.desc": "插入表格",
  "tinymce.table.fixed_width": "固定寬度",
  "tinymce.table.fixed_width_tooltip": "拖曳欄邊框以設定寬度。表格永遠會以您設定的寬度顯示。",
  "tinymce.table.highlight_colour": "醒目提示顏色",
  "tinymce.table.merge_cells_desc": "合併表格儲存格",
  "tinymce.table.more.heading": "表格設定",
  "tinymce.table.numbering_column_desc": "插入編號欄",
  "tinymce.table.paste_row_after_desc": "在此項目後面貼上列：",
  "tinymce.table.paste_row_before_desc": "貼上表格列",
  "tinymce.table.paste_row_before_shortcut": "Ctrl+Shift+V",
  "tinymce.table.responsive": "有回應",
  "tinymce.table.responsive_tooltip": "當您新增內容時，表格欄會變得更寬。拖曳欄邊框以設定相對於彼此和頁面的寬度。",
  "tinymce.table.row": "列",
  "tinymce.table.row_after_desc": "在此項目後面插入列：",
  "tinymce.table.row_after_desc_shortcut_mac": "Control+Option+↓",
  "tinymce.table.row_after_desc_shortcut_win": "Alt+Shift+↓",
  "tinymce.table.row_after_shortcut": "Alt+↓",
  "tinymce.table.row_before_desc": "在此項目之前插入列：",
  "tinymce.table.row_before_desc_shortcut_mac": "Control+Option+↑",
  "tinymce.table.row_before_desc_shortcut_win": "Alt+Shift+↑",
  "tinymce.table.row_before_shortcut": "Alt+↑",
  "tinymce.table.row_highlight": "標題列",
  "tinymce.table.selection_highlight": "變更儲存格顏色",
  "tinymce.table.split_cells_desc": "分割已合併的表格儲存格",
  "tinymce.table_dlg.cols": "欄",
  "tinymce.table_dlg.equal.width.columns": "相等寬度的欄",
  "tinymce.table_dlg.fullwidth": "全寬",
  "tinymce.table_dlg.heading": "第一列是標題",
  "tinymce.table_dlg.invalid_table_field": "列和欄都必須是大於零的數字。",
  "tinymce.table_dlg.rows": "列",
  "tinymce.table_dlg.sizetofit": "內容大小",
  "tinymce.table_dlg.title": "插入表格",
  "tinymce.table_dlg.width": "寬度",
  "tinymce.table_shortcut": "Ctrl+Shift+I",
  "tinymce.tablepicker.insert_table": "表格",
  "tinymce.tablepicker.insert_table_title": "插入表格",
  "tinymce.tablepicker.nested_table_unsupported": "不支援巢狀表格",
  "tinymce.tablepicker.pickerbox.tooltip": "在沒有標題的表格中按住 SHIFT 鍵。",
  "tinymce.templates.actions.defined": "要插入此頁面的項目。",
  "tinymce.templates.insert-template": "範本",
  "tinymce.templates.insert-template.tooltip": "將範本項目插入此頁面。",
  "tinymce.templates.placeholder": "指示性文字",
  "tinymce.templates.placeholder.add": "預留位置",
  "tinymce.templates.placeholder.add.tooltip": "在頁面中插入文字預留位置。",
  "tinymce.templates.placeholder.tooltip": "在使用者輸入資料時消失，而檢視頁面時不會顯示。",
  "tinymce.templates.variables.add": "新增變數",
  "tinymce.templates.variables.add.tooltip": "將新欄位插入頁面中，以便範本使用者填寫。",
  "tinymce.templates.variables.defined": "要插入此頁面的變數。",
  "tinymce.templates.variables.insert.tooltip": "將 '{'0'}' 欄位插入頁面，做為使用者填寫的範本。",
  "tinymce.templates.variables.manage": "管理變數",
  "tinymce.templates.variables.none": "未定義變數",
  "tinymce.templates.variables.none.tooltip": "未建立任何變數。",
  "tinymce.tools.toolbar_item_hide": "隱藏工具",
  "tinymce.tools.toolbar_item_hide_title": "隱藏工具列",
  "tinymce.tools.toolbar_item_show": "顯示工具",
  "tinymce.tools.toolbar_item_show_title": "顯示工具列",
  "tinymce.web.css.resource.name": "Confluence 編輯器 CSS Web 資源",
  "tinymce.web.js.resource.name": "Confluence 編輯器 Javascript Web 資源",
  "tinymce.web.resource.name": "Confluence 編輯器 Web 資源",
  "title.add.blogpost": "新增部落格貼文",
  "title.add.page": "新增頁面",
  "title.add.page.template": "建立範本",
  "title.comment": "留言",
  "title.dashboard": "儀表板",
  "title.edit.page.template": "編輯範本",
  "title.manage.groups": "群組",
  "title.name": "標題",
  "type.allcontent": "所有內容",
  "unknown.file": "檔案",
  "unsaved.comment.lost": "您的留言將會遺失。",
  "unsaved.content.lost": "您所做的變更可能無法儲存。",
  "unsaved.template.lost": "您將失去未儲存的範本變更。",
  "untitled.draft.title": "未命名",
  "upm.marketplace.section": "Atlassian Marketplace",
  "usermanagement.label": "使用者管理",
  "usermanagement.parent.label": "網站管理",
  "users.name": "使用者",
  "view-changes-dialog.close.dialog": "關閉",
  "view-changes-dialog.editor.quit-dialog.title.diff": "未發佈的變更",
  "view.change": "檢視變更",
  "view.profile": "檢視個人檔案",
  "viewdrafts.page.desc": "當您編輯頁面但未發佈變更時，就會建立草稿。按一下「<b>繼續</b>」以繼續編輯或發佈變更。",
  "welcome.message.edit": "在此分享有用的連結、公告和資訊",
  "welcome.message.edit.link": "自訂",
  "word.file": "Microsoft Word 文件",
  "word.template.file": "Microsoft Word 範本",
  "word97.file": "Microsoft Word 97 文件",
  "word97.template.file": "Microsoft Word 97 範本",
  "xml.file": "XML 檔案",
  "yes.name": "是",
  "your.profile.and.settings": "您的個人檔案和設定",
  "zip.file": "ZIP 封存"
}